<template>
  <page-outline :title="$t('requestToPay.new_req_to_pay')"
    icon="icon-sent" noReturn returnUrl="/home/"
    pageClass="rtp_request">

    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-if="!activateSpinner" class="ml-3 mr-3">
        <!-- ====================================== -->
        <!--          INVOICES ATTACHMENTS          -->
        <!-- ====================================== -->
        <form-accordion :title="$t('attachments.doc')" :isTitleUpperCase="false"
          v-if="rtpType === 'unit'">
          <b-row>
            <b-col>
              <div v-if="typeFile === '1' && attachments.length > 0">
                <b-row v-for="(attachment, id) in attachments" :key="id"
                  class="align-items-center justify-content-start mx-0 px-0">
                  <b-col xl="3" cols="7" class="form-group ml-0">
                    <div class="d-flex justify-content-between">
                      <label>
                        {{ attachment.AttachmentName }}
                      </label>
                      <div class="d-flex">
                        <i class="fa-light fa-download ml-3" @click="view(id)"></i>
                        <i class="fa-light fa-magnifying-glass ml-5" @click="openDoc(id)"></i>
                      </div>
                    </div>
                  </b-col>
                  <b-button variant="primary" round class="mb-3 w-auto px-4"
                    @click="clearInvoice(id)">
                    {{ $t('common.del_label') }}
                  </b-button>
                  <!-- <b-col class="form-group">
                    <form-write-group-label-input v-model="attachment.AttachmentReference"
                      v-if="attachment.AttachmentName !== ''"
                      :placeholderValue="$t('common.rfrnc')">
                    </form-write-group-label-input>
                  </b-col> -->
                </b-row>
                <b-row>
                  <b-col xl="4" cols="4" class="form-group" v-if="isNorm('SRTP')">
                    <b-form-checkbox v-model="addDocToRTP">{{$t('requestToPay.add_attachment_rtp')}}</b-form-checkbox>
                  </b-col>
                </b-row>
              </div>
              <b-row class="justify-content-start" v-if="typeFile === '1'">
                <b-col cols="12" class="form-group">
                  <b-button variant="tertiary" round class="w-auto px-4"
                    @click="openImportAttachmentInvoice(typeFile)" :disabled="!canSendAttachment">
                    <!--<i class="fa-light fa-upload mr-2" size="17px"></i>-->
                    {{ fileIsFacturX ? (attachments.length ? $t('attachments.replace_facturx') : $t('attachments.import_facturx')) : $t('attachments.import_doc') }}
                  </b-button>
                </b-col>
                <b-col class="form-group" v-if="isSmartphoneOS">
                  <b-button round class="generalBottomButton"
                    @click="scanDocument($event)">
                    <span>{{ $t('creation_forms.tke_doct_pctr') }}</span>
                  </b-button>
                </b-col>
                <input class="item-input hiddenElementAllSize local-file-input"
                  accept=".jpeg,.jpg,.png,.pdf"
                  type="file"
                  :key="refreshImport"
                  :disabled="!canSendAttachment"
                  @change="executeOCR($event,'INVOICE')"
                />
                <input class="hiddenElementAllSize"
                  type="text"
                  :disabled="canSendAttachment"
                />
                <input class="hiddenElementAllSize"
                  type="text" id="recommendation-list-input"
                  :disabled="canSendAttachment"
                />
              </b-row>
              <b-row v-if="this.attachments.length">
                <b-col sm="6" class="form-group">
                  <!-- FILES ALREADY IMPORTED FROM MONEYROAD BEGIN -->
                  <select class="form-control" v-model="attachmentId" v-if='typeFile === "2"'
                    @change="cloudFileSel()" :disabled="!canSendAttachment">
                    <option value="" default disabled>
                      {{ this.hasCloudAttachments ? $t('creation_forms.slct_a_fl') : $t('attachments.no_document')
                      }}
                    </option>
                    <option v-for="cloudDoc in cloudDocsPicker" :key="cloudDoc.id" :value="cloudDoc.id">
                      {{ cloudDoc.name }}
                    </option>
                  </select>
                  <!-- FILES ALREADY IMPORTED FROM MONEYROAD END -->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </form-accordion>

        <hr v-if="rtpType === 'unit'" class="mx-auto"/>

        <!-- ====================================== -->
        <!--            RECIPIENTS LIST             -->
        <!-- ====================================== -->
        <form-accordion :title="rtpType === 'group' ? $t('creation_forms.dbtrs_info') : $t('creation_forms.dbtr_info')" class="group-border p-0 m-0" :isTitleUpperCase="false" :class="showOptions ? '': ' mb-5'">
          <b-row v-for="(debtor, debtorIndex) in enteredDebtors" :key="debtor.debtorId">
            <b-col>
              <b-row class="justify-content-start">
                <template v-if="isDebtorAnonymous(debtor)">
                  <b-col cols="5" xl="3" class="text-center justify-content-between" align-self="center">
                    <b-row>
                      <b-col cols="6" align-self="center" class="pr-0" text-align="left">
                        <p>
                          {{$t('requestToPay.anon_debtor')}}
                          <span v-if="enteredDebtors.length > 1">
                            {{(parseInt(debtor.debtorId) + 1).toString()}}
                          </span>
                        </p>
                      </b-col>
                      <b-col cols="6" align-self="center" text-align="left" class="pl-1">
                        <i class="fa-light fa-check text-success"></i>
                      </b-col>
                    </b-row>
                  </b-col>
                </template>
                <template v-else>
                  <b-col class="form-group" cols="12" sm="6" md="4" :xl="rtpType === 'group' ?  '3' : '4'">
                    <form-contact-dropdown-label-input v-model="debtor.debtorName" isMandatory
                      :id="'debtor-name-' + debtorIndex.toString()"
                      labelClass="mb-0"
                      inputIcon="fa fa-magnifying-glass"
                      :inputLabel="$t('common.debtor_name')"
                      :placeholderValue="$t('common.nme')"
                      :mandatoryErrorIndicator="beneficiaireError"
                      @input="debtor.debtorSelected = false"
                      @change-iban="debtor.debtorBank = $event"
                      @change-identifier="debtor.debtorEmail = $event"
                      @change-contact="changeContact($event, debtor, debtorIndex)">
                    </form-contact-dropdown-label-input>
                  </b-col>
                  <b-col class="form-group" cols="12" sm="6" md="4">
                    <form-write-group-label-input v-model="debtor.debtorBank" isMandatory
                      :id="'debtor-srtp-id-provider-' + debtorIndex.toString()"
                      labelClass="mb-0"
                      :inputLabel="$t('common.rtp_dbtr_ibn')"
                      :disabled="debtor.debtorSelected || (debtor.debtorSelected && debtor.debtorImportedFound)"
                      :specificErrorIndicator="ibanFormatError"
                      :specificMessage="$t('errors.invld_iban_frmt')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col class="form-group" cols="12" sm="6" md="4" :xl="rtpType === 'group' ?  '3' : '4'">
                    <form-write-group-label-input v-model="debtor.debtorIdProvider" isMandatory
                      :id="'debtor-srtp-id-provider-' + debtorIndex.toString()"
                      labelClass="mb-0"
                      :inputLabel="$t('common.recipient_srtp_id_provider')"
                      :disabled="debtor.debtorSelected || (debtor.debtorSelected && debtor.debtorImportedFound)"
                      :tooltipLabel="debtorHasNorm ? undefined : $t('common.id_provider_tooltip')"
                      :specificErrorIndicator="isNorm('NONE') || isNorm('FORBIDDEN')"
                      :specificMessage="isNorm('FORBIDDEN') ? $t('errors.no_norm_allowed') : $t('errors.no_norm_found_for_identifier')"
                      @blur="changeDebtorIdProvider(debtor)">
                    </form-write-group-label-input>
                  </b-col>
                </template>
                <b-col class="form-group pl-2 mb-0" xl="2" cols="6" v-if="rtpType === 'group'">
                  <form-write-group-label-input v-model="debtor.amount"
                    :id="'debtor-amount-' + debtorIndex.toString()"
                    :isMandatory="!amountModifAccepted"
                    labelClass="mb-0"
                    inputType="number"
                    :inputLabel="$t('common.due_amnt') + ' ' + zoneCodeToSign(zoneCode)"
                    :placeholderValue="$t('common.due_amnt')"
                    :typingDone="changeAmountTotal"
                    :disabled="enteredDebtors.length > 1 && parseInt(debtor.debtorId) === enteredDebtors.length - 1">
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="2" v-if="isDebtorAnonymous(debtor)" class="form-group mb-0">
                  <span class="col-1 fa fa-times-circle text-danger fs-25px mt-30px cursor" @click="cancelDebtor(debtor)"></span>
                </b-col>
              </b-row>
              <b-row>
                <template v-if="debugQRCode && debtor.debtorToken !== ''" >
                  <b-col cols="6" class="fs-9px color-col-recipient">
                    <b>Token: </b> {{debtor.debtorToken}}
                  </b-col>
                </template>
              </b-row>
            </b-col>
          </b-row>
        </form-accordion>
        <hr v-if="showOptions && debtorHasNorm" class="mx-auto"/>

        <!-- ====================================== -->
        <!--            PAYMENT DETAILS             -->
        <!-- ====================================== -->
        <form-accordion id="payment-details" :title="$t('common.formsSubTitle.rqst_to_pay_dtls')" :isTitleUpperCase="false" v-if="debtorHasNorm">
          <b-row class="form-group">
            <b-col cols="4">
              <form-write-group-label-input v-model="invoiceReference"
                inputType="text"
                :maxLength="35"
                :colLabelSize="4"
                :colInputSize="8"
                labelClass="mb-0"
                :inputLabel="$t('common.invc_ref')"
                :placeholderValue="$t('common.invc_ref')"
                :tooltipLabel="$t('common.invc_ref_tooltip')">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="4" v-if="isNorm('SRTP')">
              <form-write-group-label-input v-model="uri"
                inputType="text"
                :maxLength="2041"
                :colLabelSize="4"
                :colInputSize="8"
                labelClass="mb-0"
                :inputLabel="$t('common.uri')"
                :placeholderValue="$t('common.uri')">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="4">
            </b-col>
          </b-row>
          <b-row v-if="hasRight('rtp_group_create')">
            <b-col xl="3" cols="12" class="pb-3">
              <b-form-radio-group v-model="rtpType">
                <b-form-radio name="rtpType-radio" value="unit">{{ $t('common.tab_unit') }}</b-form-radio>
                <b-form-radio name="rtpType-radio" value="group">{{ $t('common.tab_group') }}</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col cols="12" sm="6" md="4" xl="4" class="mb-3 mb-md-0">
              <form-write-group-label-input v-model="remittanceInformation" isMandatory
                inputType="text"
                :maxLength="140"
                :colLabelSize="4"
                :colInputSize="8"
                labelClass="mb-0"
                :inputLabel="$t('common.rsn')"
                :placeholderValue="$t('common.enter_reason')">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="4" class="mb-3 mb-sm-0">
              <form-write-group-label-input v-model="amountTotal" isMandatory isNotZero
                inputType="number"
                :colLabelSize="4"
                :colInputSize="8"
                :minValue="0"
                labelClass="mb-0"
                :inputLabel="$t('common.amnt_ttl_rtp') + ' ' + zoneCodeToSign(zoneCode)"
                :placeholderValue="$t('common.amnt_ttl_rtp') + ' ' + zoneCodeToSign(zoneCode)"
                :specificErrorIndicator="maxAmountError"
                :specificMessage="maxAmountError ? $t(maxAmountErrorText, {maxAmount: maxAmount}) : $t('errors.amnt_ttl_chngd')"
                @blur="changeDebtorsAmount">
              </form-write-group-label-input>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="4">
              <select-bank-account v-model="creditorBank"
                labelClass="mb-0"
                inputClass="d-flex align-items-center icon-input bank-account-icon"
                inputIcon="fa-solid fa-building-columns text-info">
              </select-bank-account>
            </b-col>
          </b-row>
          <b-row class="my-2" v-if="rtpType === 'group'">
            <b-col xl="3" cols="6">
              <form-write-group-label-input v-model="nbDebtors" isMandatory
                labelClass="mb-0"
                inputType="number" :minValue="2" :maxValue="10"
                :inputLabel="$t('common.nbr_debtor')"
                :placeholderValue="$t('common.nbr_debtor')">
              </form-write-group-label-input>
            </b-col>
            <!-- <b-col xl="3" cols="6" class="mt-3">
              <form-write-group-label-input v-model="otherIdentifier"
                inputType="text"
                :colLabelSize="4"
                :colInputSize="8"
                inputClass=""
                labelClass="mb-0"
                :inputLabel="$t('common.other_id')"
                :placeholderValue="$t('common.other_id')">
              </form-write-group-label-input>
            </b-col> -->
          </b-row>
        </form-accordion>

        <hr v-if="debtorHasNorm" class="mx-auto mt-5"/>

        <form-accordion id="payment-terms" :title="$t('common.formsSubTitle.rqst_to_pay_terms')" :isTitleUpperCase="false" v-if="debtorHasNorm && isNorm('SRTP')">
          <b-row class="form-group removeJustifyOnXL">
            <b-col xl="2" cols="2" class="mt-3 pr-2" v-if="isNorm('SRTP')">
              <b-form-checkbox v-model="acceptNow">{{ $t('requestToPay.accept_now') }}</b-form-checkbox>
            </b-col>
            <b-col cols="4" lg="3" xl="2" v-if="!acceptNow && isNorm('SRTP')">
              <form-write-group-label-input v-model="formattedExpirationDate" isMandatory
                :colLabelSize="12"
                :colInputSize="12"
                inputIcon="fa-solid fa-calendar text-info"
                labelClass="mb-0"
                inputType="datetime" disablePastDateTimes
                :inputLabel="$t('requestToPay.accept_with') + ' ' + $t('common.expiration_date_label')"
                :placeholderValue="$t('common.slct_date')">
              </form-write-group-label-input>
            </b-col>
            <b-col lg="7" xl="8"></b-col>
          </b-row>
          <b-row class="form-group removeJustifyOnXL" v-if="!multiInstallments" :key="multiInstallments">
            <b-col cols="2" xl="2" class="mt-3 pr-2" v-if="!creditNote && isNorm('SRTP')">
              <b-form-checkbox v-model="payNow">{{ $t('requestToPay.pay_now') }}</b-form-checkbox>
            </b-col>
            <b-col cols="2" xl="2" class="mt-3 pr-2" v-else-if="creditNote">
            </b-col>
            <b-col cols="4" lg="3" xl="2" v-if="isNorm('SRTP') && !payNow">
              <form-write-group-label-input v-model="formattedExecutionDate" isMandatory
                :colLabelSize="12"
                :colInputSize="12"
                inputIcon="fa-solid fa-calendar text-info"
                labelClass="mb-0"
                inputType="datetime" disablePastDateTimes
                :inputLabel="$t('common.pay_with') + ' ' + $t('common.execution_date_label')"
                :placeholderValue="$t('common.slct_date')">
              </form-write-group-label-input>
            </b-col>
            <b-col lg="7" xl="8"></b-col>
          </b-row>

          <!-- ====================================== -->
          <!--           MULTI INSTALMENTS            -->
          <!-- ====================================== -->
          <b-row class="form-group justify-content-start" v-if="!creditNote">
            <b-col cols="5" sm="4" xl="2" class="mt-3 pr-2 d-flex justify-content-between mb-3" v-if="isNorm('SRTP')">
              <b-form-checkbox v-model="multiInstallments">{{ $t('requestToPay.pay_installment') }}</b-form-checkbox>
              <label v-if="multiInstallments"><i class="fa fa-plus pt-6px" @click="addInstallment"></i></label>
              <span></span>
            </b-col>
            <b-col cols="12" sm="10" lg="7" class="mt-3" v-if="multiInstallments && isNorm('SRTP')" :key="installmentRefresh">
              <b-row v-for="(installment, indexInstallment) in formattedInstallmentsDate" :key="indexInstallment" class="form-group justify-content-start" :class="(indexInstallment + 1) === installments.length ? 'mb-0' : ''">
                <b-col cols="5" xl="4">
                  <form-write-group-label-input v-model="installments[indexInstallment].date" isMandatory
                    :colLabelSize="12"
                    :colInputSize="12"
                    inputIcon="fa-solid fa-calendar text-info"
                    labelClass="mb-0"
                    inputType="datetime" disablePastDateTimes
                    :inputLabel="$t('common.execution_date_label') + ' ' + (indexInstallment + 1)"
                    :placeholderValue="$t('common.slct_date')"
                    @blur="changeDebtorsDate">
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="4" class="float-right">
                  <form-write-group-label-input v-model="installments[indexInstallment].amount" isMandatory
                    inputType="number"
                    :colLabelSize="12"
                    :colInputSize="12"
                    :minValue="0"
                    labelClass="mb-0"
                    inputClass="installmentAmount"
                    :inputLabel="$t('common.amnt_installment_rtp') + ' ' + (indexInstallment + 1) + ' ' + zoneCodeToSign(zoneCode)"
                    :placeholderValue="$t('common.amnt_installment_rtp') + ' ' + (indexInstallment + 1) + ' ' + zoneCodeToSign(zoneCode)"
                    :specificMessage="$t('errors.amnt_ttl_chngd')"
                    @blur="changeDebtorsAmount">
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="1">
                  <i v-if="canDeleteInstallment" class="fa fa-times pt-26px" @click="deleteInstallment(indexInstallment)"></i>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- ====================================== -->
          <!--              CREDIT NOTE               -->
          <!-- ====================================== -->
          <b-row class="form-group justify-content-start" v-if="!multiInstallments">
            <b-col xl="4" cols="4" class="mt-3 mr-5 pr-2" v-if="isNorm('SRTP') && !multiInstallments">
              <b-form-checkbox v-model="creditNote">{{ $t('requestToPay.credit_note') }}</b-form-checkbox>
            </b-col>
          </b-row>
            <b-col sm="5" xl="5">
              <b-row class="d-none">
                <b-col sm="4" offset-sm="8" xl="3" offset-xl="9" class="form-group">
                  <b-form-checkbox v-model="instantPayment"
                    :value="1" :unchecked-value="0"
                    @change="changeInstPmt">
                    {{ $t('creation_forms.isSCTInst') }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <!-- <b-row class="form-group justify-content-end" v-if="rtpType === 'group'"> -->
              <!--
              <b-row class="form-group justify-content-end">
                <b-col cols="8">
                  <div class="text-right font-weight-bold fs-12px w-100">
                    <font :color="sumColor">
                      {{ amountTotalSaved === '' ? '0' + '€' : amountTotalSaved + '€' }}
                    </font>
                    <span>{{ $t('common.of_label') }}</span>
                    <font color="#12bcf1">
                      {{ amountTotal === '' ? '0' + '€' : amountTotal + '€' }}
                    </font>
                  </div>
                </b-col>
              </b-row>-->
            </b-col>
        </form-accordion>
        <hr v-if="debtorHasNorm && isNorm('SRTP')" class="mx-auto mt-5"/>

        <!-- ====================================== -->
        <!--              RTP SETTINGS              -->
        <!-- ====================================== -->
        <form-accordion :title="$t('common.formsSubTitle.rqst_to_pay_sttngs')" :isTitleUpperCase="false" v-if="showOptions && (hasRight('rtp_option_amount_modify') || hasRight('rtp_option_multiple_dates_installment')) && debtorHasNorm">
          <b-row>
            <!-- =================================== -->
            <!--           OPTIONS CHECKBOX          -->
            <!-- =================================== -->
            <b-col sm="6" class="form-group">
              <!-- <b-form-checkbox class="mt-sm-2 d-none" v-model="ibanModifAccepted"
                id="iban-edt-accpt"
                :value="true" :unchecked-value="false">
                {{ $t('requestToPay.bankAccountModif') }}
              </b-form-checkbox> -->
              <b-form-checkbox class="mt-sm-2" v-model="amountModifAccepted" :disabled="creditNote" :value="true" :unchecked-value="false" v-if="hasRight('rtp_option_amount_modify')">
                {{ $t('creation_forms.dbtr_may_ngtt_amnt') }}
              </b-form-checkbox>
              <b-form-checkbox class="mt-sm-2" v-model="dateModifAccepted" :disabled="creditNote" :value="true" :unchecked-value="false" v-if="hasRight('rtp_option_date_modify') && isNorm('SRTP')">
                {{ $t('creation_forms.dbtr_may_chng_date') }}
              </b-form-checkbox>
              <b-form-checkbox class="mt-sm-2" v-model="reasonModifAccepted" :disabled="creditNote" :value="true" :unchecked-value="false" v-if="/*hasRight('rtp_option_reason_modify') A DECOMMENTE DES QUE LE DROIT EXISTERA*/ isNorm('HRTP')">
                {{ $t('creation_forms.dbtr_may_chng_rson') }}
              </b-form-checkbox>
              <!-- <b-form-checkbox class="mt-sm-2 d-none" v-model="installmentsAccepted"
                id="instllmnts-accpt"
                :value="true" :unchecked-value="false" v-if="hasRight('rtp_option_multiple_dates_installment')">
                {{ $t('creation_forms.allowMultipleInst') }}
              </b-form-checkbox> -->
            </b-col>

            <!-- DEBUT VIEUX CODE -->
            <b-col id="settings-delay" sm="6" class="form-group d-none">
              <!-- =================================== -->
              <!--    DOES ACCEPT NOW RADIO BUTTONS    -->
              <!-- =================================== -->
              {{ $t('common.acceptance') }}: <br />

              <b-form-group id="settings-delay-accept">
                <b-form-radio v-model="doesAcceptNow" name="acceptance-radio" value="now">
                  {{ $t('common.accept_now') }}
                  <input :disabled="doesAcceptNow !== 'now'" class="miniFormControl" type="text"
                    id="settings-delay-accept-time"
                    v-model="acceptExpirationTime"
                    @input="acceptExpirationTime = isNaN(parseInt(acceptExpirationTime)) ? 1
                                    : (parseInt(acceptExpirationTime) <= 0 ? 1 : parseInt(acceptExpirationTime))" />
                  {{ $t('common.after_sent') }}
                </b-form-radio>
                <b-form-radio v-model="doesAcceptNow" name="acceptance-radio" value="later">
                  {{ $t('common.accept_later') }}
                </b-form-radio>
              </b-form-group>

              <!-- =================================== -->
              <!--     DOES PAY NOW RADIO BUTTONS      -->
              <!-- =================================== -->
              {{ $t('requestToPay.payment') }}: <br />
              <b-form-group id="settings-delay-pay">
                <b-form-radio v-model="doesPayNow" @change="isSCTInst = false" name="payment-radio" value="none">
                  {{ $t('common.no_mr_payment') }}
                </b-form-radio>
                <b-form-radio v-model="doesPayNow" name="payment-radio" value="now">
                  {{ $t('common.aftr_accpt') }}
                  <input :disabled="doesPayNow !== 'now'" class="miniFormControl" type="text"
                    id="settings-delay-pay-time"
                    v-model="payExpirationTime" @input="payExpirationTime = isNaN(parseInt(payExpirationTime)) ? 1
                                    : (parseInt(payExpirationTime) <= 0 ? 1 : parseInt(payExpirationTime))">
                  {{ $t('common.after_hours') }}
                </b-form-radio>
                <b-form-radio v-model="doesPayNow" @change="isSCTInst = false" name="payment-radio" value="later">
                  {{ $t('common.payment_later') }}
                </b-form-radio>
              </b-form-group>
            </b-col>
            <!-- FIN VIEUX CODE -->
          </b-row>
        </form-accordion>
        <!-- ====================================== -->
        <!--             BOTTOM BUTTONS             -->
        <!-- ====================================== -->
        <!-- <div slot="footerButtons"> -->
        <b-row>
          <b-col>
            <span class="color-red">* {{ $t('common.required_fields') }}</span>
          </b-col>
          <div class="justify-content-end" v-if="debtorHasNorm">
            <b-button class="mr-5" variant="tertiary" @click="resetForm">
              <!-- <i class="icon fa fa-repeat"></i> -->
              <span class="d-none d-xl-inline">{{ $t('common.rst') }}</span>
              <span class="d-xl-none">{{ $t('common.rst') }}</span>
            </b-button>
            <!-- <b-col lg="2" cols="6" class="mb-3">
              <b-button class="btn">
                <i class="icon fa fa-save"></i>
                <span class="d-none d-xl-inline">{{ $t('common.sve') }}</span>
                <span class="d-xl-none">{{ $t('common.sve') }}</span>
              </b-button>
            </b-col> -->
            <b-button class="mr-3" variant="primary" size="sm" @click="sendPayments">
              <!-- <i class="icon fa fa-paper-plane"></i> -->
              <span class="d-none d-xl-inline">{{ $t('creation_forms.snd_req') }}</span>
              <span class="d-xl-none">{{ $t('creation_forms.snd') }}</span>
            </b-button>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import b64toBlob from 'b64-to-blob'
import moment from 'moment'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formContactDropdownLabelInput from '@/components/common/formContactDropdownLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'
import Spinner from '@/components/common/spinner.vue'

import { errorMessageAlert } from '@/helpers/alert'
import { formatDateTime } from '@/helpers/format'
import { statusLabel, statusIcon, getCancelLabel, currencySymbol } from '@/helpers/labels'
import { loadPage } from '@/helpers/routing'
import Services from '@/helpers/services'
import { validateEmail, validateIBAN, validateIBANRIBKey, validateSIREN } from '@/helpers/validator'

export default {
  name: 'PRCreateTemplate',
  props: ['subNavTitle', 'capsule', 'saveMessage'],
  components: {
    'form-accordion': FormAccordion,
    'form-contact-dropdown-label-input': formContactDropdownLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'select-bank-account': selectBankAccount,
    'spinner': Spinner
  },
  data () {
    return {
      acceptExpirationTime: '10',
      acceptNow: false,
      activateSpinner: false,
      addDocToRTP: false,
      amountModifAccepted: false,
      amountTotal: '',
      amountTotalSaved: '',
      attachmentData: '',
      attachmentId: '',
      attachmentName: '',
      attachmentReference: '',
      attachmentReferenceError: false,
      attachments: [],
      bankAccounts: [],
      beneficiaire: '',
      beneficiaireError: false,
      canSendAttachment: false,
      cloudDocsPicker: '',
      cloudFiles: [],
      contacts: [],
      contactsObject: {},
      contactsPicker: '',
      contactSelectionList: [],
      creditNote: false,
      creditorBank: '',
      creditorBankName: '',
      dateModifAccepted: false,
      debtorBank: '',
      debtorEmail: '',
      debtorName: '',
      debtorData: {},
      debtorIdCompany: '',
      debtorIdProvider: '',
      debtorZoneCode: '',
      debugQRCode: false, // If false, debug div wont be display
      doesAcceptNow: 'now',
      doesPayNow: 'later',
      draftName: '',
      enteredDebtors: [],
      executionDate: '',
      expirationDate: '',
      fileEvent: '',
      fileIsFacturX: true,
      fileTypeSelect: [
        {
          text: this.$i18n.t('common.classic_invce_radio'),
          value: false
        },
        {
          text: this.$i18n.t('common.facturx_radio'),
          value: true
        }
      ],
      fromCloud: false,
      hasCloudAttachments: false,
      ibanModifAccepted: false,
      ibanFormatError: false,
      idDraft: '',
      ImmPmtAccepted: false,
      installmentsAccepted: false,
      installments: [],
      installmentRefresh: false,
      instantPayment: 1,
      invoiceReference: '',
      isOcrActive: true,
      isSCTInst: false,
      lastProviderTested: '',
      loadingFile: false,
      maxAmount: '',
      maxAmountError: false,
      maxAmountErrorText: '',
      multiInstallments: false,
      nbDebtors: '1',
      norm: '',
      otherIdentifier: '',
      payExpirationTime: '10',
      payNow: false,
      paymentOption: ['normal', 'CB', 'SCTInst'],
      reasonModifAccepted: false,
      refreshImport: false,
      remittanceInformation: '',
      rtpType: 'unit',
      selected: [],
      selectedContact: false,
      selectedDebtors: {},
      showOptions: true,
      settings: this.$engine.settings.get(Services.PAYMENTS),
      typeFile: '1',
      typeOfRTP: '1',
      uri: '',
      zoneCode: ''
    }
  },
  computed: {
    canDoHRTP () {
      return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
    },
    canDoSRTP () {
      return this.$engine.rights.rightIs('rtp_norm_srtp', true)
    },
    canSeeRTPBack() {
      return this.$engine.rights.rightIs('rtp_backoffice_consulter', true)
    },
    canSeeRTPFront() {
      return this.$engine.rights.rightIs('rtp_sendbox_consulter', true)
    },
    debtorHasNorm () {
      return ['SRTP', 'HRTP'].includes(this.norm)
    },
    formattedInstallmentsDate: {
      get () {
        let installmentsTmp = []
        this.installments.forEach((installment, indexInstallment) => {
          let val = {}
          if (installment.date.length > 0) {
            val = {'amount': installment.amount, 'date': moment(installment.date).format("YYYY-MM-DDTHH:mm")}
          } else {
            val = {'amount': installment.amount, 'date': ''}
          }
          installmentsTmp.push(val)
        })
        return installmentsTmp
      },
      set (value) {
        this.installments = []
        value.forEach((installment, indexInstallment) => {
          let val = {'amount': installment.amount, 'date': formatDateTime(installment.date)}
          this.installments.push(val)
          // console.log("add installement", val)
        })
      },
    },
    formattedExecutionDate: {
      get () {
        return moment(this.executionDate).format('YYYY-MM-DDTHH:mm')
      },
      set (value) {
        this.executionDate = formatDateTime(value)
      }
    },
    formattedExpirationDate: {
      get () {
        return moment(this.expirationDate).format('YYYY-MM-DDTHH:mm')
      },
      set (value) {
        this.expirationDate = formatDateTime(value)
      }
    },
    formattedInstallementDate () {
      return (index) => {
        // Renvoie la valeur formatée en fonction de l'index de l'élément du tableau
        return this.installments[index].date // Exemple de formatage avec deux décimales
      }
    },
    getDefaultNorm () {
      if (this.$engine.rights.rightIs('rtp_norm_srtp', true) && this.$engine.rights.rightIs('rtp_norm_hrtp', false)) {
        return 'SRTP'
      }
      else if (this.$engine.rights.rightIs('rtp_norm_hrtp', true) && this.$engine.rights.rightIs('rtp_norm_srtp', false)) {
        return 'HRTP'
      }
      return ''
    },
    canDeleteInstallment () {
      return this.installments.length > 2
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    //readonly () {
    //  return this.accountType === '1' && this.isComplete === '1' && (this.isValidated === '1' || this.isValidated === '2')
    //},
    sumColor () {
      if (Number(this.amountTotal) === Number(this.amountTotalSaved)) {
        return '#12bcf1'
      } else {
        return 'red'
      }
    }
  },
  watch: {
    creditNote (val) {
      if (val) {
        this.multiInstallments = false
        this.amountModifAccepted = false
        this.dateModifAccepted = false
        this.reasonModifAccepted = false
      }
    },
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader(this.$i18n.t('common.imprtng'))
      } else {
        this.$f7.hidePreloader()
      }
    },
    multiInstallments (val) {
      if (val) {
        this.amountModifAccepted = false
        this.dateModifAccepted = false
        this.reasonModifAccepted = false
        if (this.installments.length === 0) {
          this.installments.push({amount: this.amountTotal, date: ''})
          this.installments.push({amount: '', date: moment(this.executionDate).format('YYYY-MM-DDTHH:mm:ss')})
          this.changeDebtorsAmount(true)
        } else {
          this.changeDebtorsAmount()
        }
      } else {
        this.installments = []
      }
    },
    nbDebtors (newVal, oldVal) {
      oldVal = parseInt(oldVal) ? parseInt(oldVal) : 1
      newVal = parseInt(newVal) ? parseInt(newVal) : 1
      if (newVal < 2 || newVal > 10 || this.enteredDebtors.length === newVal) {
        return
      }
      if (oldVal <= 1 || oldVal > 10) {
        oldVal = this.enteredDebtors.length
      }
      if (newVal > oldVal) {
        for (var i = 0; i < newVal - oldVal; i++) {
          const debtorId = oldVal + i
          // pour screen RTP
          const tmpDebtorBank = this.$engine.user.userAccountId === '1' ? 'FR3710096000407323421727V45' : 'FR7214508000502341787712J92'
          this.enteredDebtors.push({
            amount: '',
            debtorBank: tmpDebtorBank,
            debtorIdType: 'mail',
            debtorEmail: '',
            debtorId: debtorId.toString(),
            debtorName: '',
            debtorSelected: false,
            debtorToken: '',
            debtorIdCompany: '',
            debtorIdProvider: '',
            debtorImportedFound: false
          })
        }
      } else if (newVal < oldVal) {
        for (var j = 0; j < oldVal - newVal; j++) {
          this.enteredDebtors.pop()
        }
      }
      this.changeDebtorsAmount()
    },
    rtpType (val) {
      switch (val) {
        case 'unit':
          for (var j = 0; j < this.enteredDebtors.length; j++) {
            this.enteredDebtors.pop()
          }
          this.enteredDebtors[0].amount = this.amountTotal
          this.nbDebtors = '1'
          break
        case 'group':
          this.amountTotal = this.enteredDebtors[0].amount
          this.nbDebtors = '2'
          break
        default:
          break
      }
    }
  },
  mounted () {
    this.$engine.services.payments.contactDebtorList = []
    const defaultBankAccount = this.$engine.bankAccounts.get().find(elem => elem.isDefault === '1')
    if (defaultBankAccount) {
      this.creditorBank = defaultBankAccount.iban
      this.creditorBankName = defaultBankAccount.name
      this.zoneCode = defaultBankAccount.zoneCode
    }
    this.isOcrActive = this.$engine.settings.get(Services.PAYMENTS).ocrActivation === '1'
  },
  created () {
    // activate set norm by default if user has only one norm
    // this.loadDefaultNorm()
    let that = this
    this.activateSpinner = true
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.canSendAttachment = this.$engine.rights.rightIs('rtp_request_add_attachment', true)
    // this.canSendAttachment = true
    if (this.$engine.settings.get(1).ocrActivation === '1') {
      this.isOcrActive = true
    }
    // this.instantPayment = this.$engine.settings.directPayments.get().pacs008 === '1' ? 1 : 0
    this.$engine.contacts.fetch()
    .finally(() => {
      this.$bus.$on('refresh-contact-payments', (data) => {
        this.debtorName = data.debtorName
        this.debtorBank = data.debtorBank
        this.debtorEmail = data.debtorEmail
        this.debtorIdCompany = data.debtorIdCompany
        this.debtorIdProvider = data.debtorIdProvider
      })
      // this.enteredDebtors = this.$engine.services.payments.debtorList
      this.enteredDebtors = []
      // pour screen RTP
      const tmpDebtorBank = undefined
      // let tmpDebtorBank = this.$engine.user.userAccountId === '1' ? 'FR3710096000407323421727V45' : 'FR7214508000502341787712J92'
      this.enteredDebtors.push({
        amount: '',
        debtorBank: tmpDebtorBank,
        debtorIdType: 'mail',
        debtorEmail: '',
        debtorId: '0',
        debtorName: '',
        debtorSelected: false,
        debtorToken: '',
        debtorIdCompany: '',
        debtorIdProvider: '',
        debtorImportedFound: false
      })
      // TODO : selected
      // this.selected = this.$engine.services.payments.contactDebtorList
      this.selected = []
      // this.setContacts()
      // Get default value for Negotiation
      // this.executionDate = this.instantPayment === 1 ? moment().format('YYYY-MM-DD') : moment().add(1, 'day').format('YYYY-MM-DD')
      this.executionDate = formatDateTime(moment().add(1,'days').format('YYYY-MM-DDT00:00'))
      this.expirationDate = formatDateTime(moment().add(1,'days').format('YYYY-MM-DDT00:00'))
      this.amountModifAccepted = this.$engine.settings.get(1).defaultNegotiationAllowed === '1'
      if (this.capsule === 'draft-edit') {
        this.$bus.$on('refresh-debtor-contact-list', (data) => {
          that.selected = data[0]
          that.selectedDebtor = {}
          that.selectedDebtor = that.contactsObject[this.selected]

          that.debtorName = that.selectedDebtor.name
          that.debtorEmail = that.selectedDebtor.identifier
          that.debtorBank = that.selectedDebtor.iban
        })
      } else {
        this.$bus.$on('refresh-debtor-contact-list', (data) => {
          const contactList = that.$engine.contacts.get()
          if (contactList) {
            const contact = contactList.find(contact => contact.id === data)
            if (contact) {
              that.debtorName = contact.name
              that.debtorEmail = contact.identifier
              that.debtorBank = contact.iban
              that.debtorIdCompany = contact.idCompany
              that.debtorProvider = contact.idProvider
              that.selectedDebtors = [{
                'name': contact.name,
                'iban': contact.iban,
                'identifier': contact.identifier,
                'idCompany': contact.idCompany,
                'idProvider': contact.idProvider
              }]
            }
          }
        })
      }
      // this.bankAccounts = this.$settings.currentAccount.ibans
      // this.cloudFiles = this.$settings.currentAccount.docs
      this.bankAccounts = this.$engine.bankAccounts.get()

      this.loadingFile = false
      this.fromCloud = false
      this.creditorBank = ''
      this.creditorBankName = ''
      this.loadPreChargedFile()
      this.loadPreChargedDraft()

      const params = {
        idAcct: this.$engine.user.get().id
      }

      if(that.$engine.rights.rightIs('attachment_consulter', true)) {
        that.$engine.attachments.getRefresh(params).then(response => {
          this.cloudFiles = response.data.docs
          const filesMap = this.cloudFiles.map(function (obj) {
            let rObj = {}
            rObj[obj.name] = {
              id: obj.id,
              name: obj.name,
              type: obj.type,
              internalReference: obj.internalReference
            }
            return rObj
          })
          const filesMapObj = Object.assign({}, ...filesMap)
          if (Object.keys(filesMapObj).length > 0) {
            this.hasCloudAttachments = true
          }
          /* let values = []
          if (Object.keys(filesMapObj).length > 0) {
            values = Object.keys(filesMapObj)
            this.hasCloudAttachments = true
          } else {
            values = ['Nothing Found']
          }*/

          this.cloudDocsPicker = filesMapObj
          /* this.cloudDocsPicker = this.$f7.picker({
            input: '#application-file-input',
            rotateEffect: true,
            cols: [
              {
                textAlign: 'center',
                values: values
              }
            ],
            onClose: function (p) {
              if (Object.keys(filesMapObj).length > 0) {
                if (filesMapObj[p.value].id !== that.attachmentId) {
                  that.attachmentId = filesMapObj[p.value].id
                  that.cloudFileSel()
                }
              }
            },
            onOpen: function (p) {
              if (Object.keys(filesMapObj).length > 0) {
                that.attachmentName = p.value
              }
            }
          })*/
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      }
      this.$bus.$on('close-popup-generate-invoice', e => {
        this.generateInvoice(e)
      })
      this.$bus.$on('close-popup-scanner-qr-code', e => {
        // console.log('got data', e)
        var result = e.split(';')
        var idDebtor = result[0]
        this.enteredDebtors[idDebtor].debtorToken = result[1]
      })
      this.activateSpinner = false
    })
  },
  beforeDestroy () {
    this.attachmentData = ''
    this.attachmentId = ''
    this.attachmentName = ''
    this.attachmentReference = ''
    this.attachments = []
    this.debtorName = ''
    this.debtorBank = ''
    this.creditorBank = ''
    this.debtorEmail = ''
    this.debtorSRTP = ''
    this.remittanceInformation = ''
    this.executionDate = ''
    this.amount = ''
    this.amountModifAccepted = false
    this.loadingFile = ''
    this.fromCloud = ''
    this.bankAccounts = []
    this.contacts = []
    this.cloudFiles = []
    this.ImmPmtAccepted = false
    this.cloudDocsPicker = ''
    this.draftName = ''
    this.$engine.services.payments.debtorList = []
    this.$engine.services.payments.contactDebtorList = []

    const attachmentObj = {
      fromCloudList: false,
      id: 0,
      name: '',
      data: '',
      amount: 0,
      reference: '',
      debtorName: '',
      executionDate: ''
    }
    const draftObj = {
      Amount: '',
      AttachmentId: '',
      AttachmentName: '',
      AttachmentReference: '',
      CreditorBankAccount: '',
      CreditorIdentifier: '',
      DebtorBankAccount: '',
      DebtorIdentifier: '',
      DebtorName: '',
      ImmPmtAccepted: '',
      amountModifAccepted: '',
      PymtNtr: '',
      RemittanceInformation: '',
      RequestedExecutionDate: '',
      draftName: '',
      idAccount: '',
      idDraft: '',
      isComplete: ''
    }
    this.$engine.settings.set({preChargedFile: attachmentObj})
    this.$engine.settings.set({preChargedDraft: draftObj})
    this.$bus.$off('close-popup-generate-invoice')
    this.$bus.$off('close-popup-scanner-qr-code')
  },
  methods: {
    addDebtor (debtor) {
      if (!debtor.debtorToken) {
        if (!debtor.debtorName) {
          this.$f7.alert('', this.$t('errors.dbtr_invld_nm'))
          return false
        }
        // if (!debtor.debtorIdCompany) {
        //   this.$f7.alert('', this.$t('errors.dbtr_mssng_id_company'))
        //   return false
        // }
        if (!debtor.debtorIdProvider) {
          this.$f7.alert('', this.$t('errors.dbtr_mssng_id_provider'))
          return false
        }
        if (!debtor.debtorBank) {
          this.$f7.alert('', this.$t('errors.dbtr_mssng_bank'))
          return false
        }
        // if (debtor.debtorEmail === '') {
        //   this.$f7.alert('', this.$t('errors.dbtr_invld_email'))
        //   return false
        // }
        // if (!validateEmail(debtor.debtorEmail) && !validateSIREN(debtor.debtorEmail)) {
        //   this.$f7.alert('', this.$t('errors.chng_the_id_to_vld_frmt'))
        //   return false
        // }
        this.$engine.services.payments.debtorList.push({
          debtorName: debtor.debtorName,
          DebtorProviderIdentifier: debtor.debtorIdProvider,
          DebtorAccountIdentifier: debtor.debtorBank
        })
      }
      return true
    },
    changeDebtorIdProvider (debtor) {
      debtor.debtorSelected = false
      if(this.$engine.rights.rightIs('rtp_norm_consulter', true)) {
        this.verifyNorm(debtor)
      }
    },
    orderInstallmentByDate () {
      this.installments.sort((a, b) => {
        if (a.date === '' && b.date === '') {
          return 0
        } else if (a.date === '') {
          return -1
        } else if (b.date === '') {
          return 1
        } else {
          return new Date(a.date) - new Date(b.date)
        }
      })
    },
    orderInstallmentByDateString(a, b) {
      // Comparer les propriétés data des objets
      if (a.date < b.date) {
        return -1
      } else if (a.date > b.date) {
        return 1
      } else {
        return 0
      }
    },
    compareByDate(b, a) {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)

      // Gérer les cas où la date est vide ou invalide
      if (isNaN(dateA)) return -1
      if (isNaN(dateB)) return 1

      return dateA - dateB
    },
    addInstallment () {
      this.installments.sort(this.orderInstallmentByDateString)
      this.installments.unshift({amount: '', date: ''})
      this.changeDebtorsAmount()
      this.installmentRefresh = !this.installmentRefresh
    },
    cancelDebtor (debtor) {
      debtor.debtorName = ''
      debtor.debtorBank = ''
      debtor.debtorEmail = ''
      debtor.debtorSRTP = ''
      debtor.debtorToken = ''
    },
    changeAmountTotal () {
      let newAmountTotal = 0
      for (var idDebtor in this.enteredDebtors) {
        if (this.enteredDebtors.length > 1 &&
          parseInt(idDebtor) === this.enteredDebtors.length - 1
        ) {
          const diff = parseFloat(this.amountTotal) - newAmountTotal
          let lastDebtor = this.enteredDebtors[idDebtor]
          if (diff >= 0) {
            lastDebtor.amount = diff.toString()
          } else {
            lastDebtor.amount = '0'
          }
        }
        newAmountTotal += parseFloat(this.enteredDebtors[idDebtor].amount)
      }

      if (newAmountTotal % 1 !== 0) {
        this.amountTotalSaved = newAmountTotal.toFixed(2).toString()
      } else {
        this.amountTotalSaved = newAmountTotal.toString()
      }
    },
    changeContact (e, debtor, debtorIndex) {
      this.debtorData = e
      this.enteredDebtors[debtorIndex].debtorIdProvider = e.idProvider
      this.enteredDebtors[debtorIndex].debtorIdCompany = e.idCompany
      if(this.$engine.rights.rightIs('rtp_norm_consulter', true)) {
        this.verifyNorm(debtor)
      }
      const that = this
      setTimeout(function () {
        that.Dom7('#debtor-srtp-id-company-' + debtorIndex.toString() + ' input').focus()
        that.Dom7('#debtor-srtp-id-provider-' + debtorIndex.toString() + ' input').focus()
        that.Dom7('button').focus()
        setTimeout(function () {
          debtor.debtorSelected = true
        }, 100)
      }, 100)
    },
    changeDebtorsAmount (changingNb = false) {
      if (this.multiInstallments) {
        if (this.amountTotal === '' || parseFloat(this.amountTotal) <= 0) {
          this.installments.forEach( (installment) => {
            if (!installment.amount) {
              installment.amount = ''
            } else {
              installment.amount = parseFloat(installment.amount).toFixed(2)
            }
          })
        } else {
          const installmentAmount = Math.floor(this.amountTotal * 100.0 / this.installments.length) / 100
          let installmentAmountTotal = 0
          let diff = -1
          let nbDiff = 0
          let amountsChanged = false
          while (diff < 0) {
            installmentAmountTotal = 0
            for (var idInstallment = 0; idInstallment < this.installments.length; idInstallment++) {
              const ornlInstallmentAmount = this.installments[idInstallment].amount
              let newAmount = ''
              if (idInstallment >= this.installments.length - 1 - nbDiff) {
                diff = parseFloat(this.amountTotal) - installmentAmountTotal
                newAmount = diff.toFixed(2).toString()
              } else if (this.installments[idInstallment].amount === '' &&
                parseFloat(this.amountTotal) - installmentAmountTotal > 0 &&
                changingNb) {
                newAmount = installmentAmount.toFixed(2).toString()
              } else {
                if (changingNb) {
                  newAmount = installmentAmount.toFixed(2).toString()
                } else if (this.installments[idInstallment].amount === '') {
                  newAmount = '0.00'
                } else {
                  newAmount = parseFloat(this.installments[idInstallment].amount).toFixed(2).toString()
                }
              }

              if (newAmount === '0.00') {
                if (this.installments[idInstallment].amount !== '' && this.installments[idInstallment].amount !== '0.00') {
                  this.installments[idInstallment].amount = ''
                }
              } else {
                if (this.installments[idInstallment].amount !== newAmount) {
                  this.installments[idInstallment].amount = newAmount
                }
              }

              if (ornlInstallmentAmount !== this.installments[idInstallment].amount) {
                amountsChanged = true
              }

              if (this.installments[idInstallment].amount !== '') {
                if (parseFloat(this.installments[idInstallment].amount) > 0) {
                  installmentAmountTotal += parseFloat(this.installments[idInstallment].amount)
                }
              }
            }
            nbDiff++
          }
          if (amountsChanged) {
            // this.Dom7('.installmentAmount input').focus()
            // this.Dom7('button').focus()
          }
        }


        /* let newAmountTotal = 0
        this.installments.forEach((installment, indexInstallment) => {
          if (installment.amount !== '' && installment.amount !== '0') {
            newAmountTotal += parseInt(installment.amount)
          }
        })
        this.amountTotal = newAmountTotal.toString() */
      }
      if (this.amountTotal !== '') {
        if (this.amountTotal.includes('e')) {
          this.amountTotal = parseFloat(this.amountTotal.split('e')[0]) * Math.pow(10, parseInt(this.amountTotal.split('e')[1]))
        }
        if(this.amountTotal.length > 16) {
          let partAfterVirgule = parseFloat('.' + this.amountTotal.slice(this.amountTotal.indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.amountTotal.split('.')[0]
          this.amountTotal = partBeforeVirgule + partAfterVirgule
        } else {
          this.amountTotal = parseFloat(this.amountTotal).toFixed(2)
        }
        this.amountTotalSaved = this.amountTotal
      }

      const debtorAmount = Math.floor(this.amountTotal * 100.0 / this.enteredDebtors.length) / 100
      for (var idDebtor = 0; idDebtor < this.enteredDebtors.length; idDebtor++) {
        let newAmount = ''
        if (idDebtor === this.enteredDebtors.length - 1) {
          newAmount = debtorAmount + (this.amountTotal - debtorAmount * this.enteredDebtors.length)
          newAmount = newAmount.toFixed(2).toString()
        } else {
          newAmount = debtorAmount.toFixed(2).toString()
        }
        if (newAmount === '0.00') {
          this.enteredDebtors[idDebtor].amount = ''
        } else {
          this.enteredDebtors[idDebtor].amount = newAmount
        }
      }
    },
    changeDebtorsDate () {
      this.installments.forEach((installment, indexInstallment) => {
        if (this.executionDate < formatDateTime(installment.date)) {
          this.executionDate = formatDateTime(installment.date)
        }
      })
      this.installments.sort(this.orderInstallmentByDateString)
      // console.log('this.installments', this.installments)
      this.installmentRefresh = !this.installmentRefresh
    },
    changeImmPmtAccepted (val) {
      this.ImmPmtAccepted = val
      this.expirationDate = val === 1 ? moment().format('YYYY-MM-DDTHH:mm:ss') : moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss')
    },
    changeInstPmt (val) {
      this.instantPayment = val
      this.executionDate = val === 1 ? moment().format('YYYY-MM-DDTHH:mm:ss') : moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss')
    },
    clearInvoice (id) {
      this.refreshImport = !this.refreshImport
      this.attachments.splice(id, 1)
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachmentId.toString())
        .then(response => {
          // let attachmentData = that.$engine.attachments.get().find(elem => elem.id === that.attachmentId)
          // that.amount = parseFloat(attachmentData.amount) % 1 === 0 ? attachmentData.amount : attachmentData.amount.toFixed(2)
          /* that.debtorName = attachmentData.debtorName
          that.debtorEmail = attachmentData.debtorEmail
          that.debtorBank = attachmentData.debtorBankAccount
          that.remittanceInformation = attachmentData.remittanceInformation
          that.executionDate = attachmentData.modDate */
          that.attachmentName = response.data.document_name
          that.attachmentData = response.data.document_data
          that.loadingFile = false
          that.attachmentReference = response.data.internal_reference
          that.Dom7('.fileNameDisplay').text(that.attachmentName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    deleteInstallment (index) {
      this.installments.splice(index, 1)
      this.changeDebtorsAmount()
      this.changeDebtorsDate()
    },
    executeFacturX (file) {
      let that = this

      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {}

      if (this.norm === 'HRTP') {
        exchangeData = {
          debtorName: 'DebtorName',
          debtorBank: 'DebtorIban',
          debtorId: 'DebtorId',
          debtorProvider: 'DebtorProviderIdentifier',
          debtorEmail: 'DebtorMail',
          creditorBank: 'CreditorIban',
          expirationDate: 'EndPeriodDate',
          amountTotal: 'AmountTTC',
          invoiceReference: 'InvoiceReference',
          remittanceInformation: 'AdditionalInformation',
          attachmentReference: 'InvoiceReference',
          paymentOption: 'PaymentOptions'
        }
      } else {
        exchangeData = {
          amountModifAccepted: 'AmountModificationAllowed',
          creditNote:'CreditNote',
          dateModifAccepted: 'EarlyPaymentAllowed',
          debtorName: 'DebtorName',
          debtorBank: 'DebtorIban',
          debtorId: 'DebtorId',
          debtorProvider: 'DebtorProviderIdentifier',
          debtorEmail: 'DebtorMail',
          creditorBank: 'CreditorIban',
          expirationDate: 'EndPeriodDate',
          executionDate: 'ExecutionDate',
          amountTotal: 'AmountTTC',
          amountTotal2: 'DuePayableAmount',
          invoiceReference: 'InvoiceReference',
          remittanceInformation: 'AdditionalInformation',
          attachmentReference: 'InvoiceReference',
          paymentOption: 'PaymentOptions',
          installments: 'Instalment'
        }
      }

      this.$f7.showPreloader(that.$i18n.t('sent.facturx_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return this.$engine.ocr.ocrInvoice(this.$engine.user.get().id, this.attachmentName, file)
      .then(response => {
        //console.log('--- response', response)
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.facturx_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()

        // Extract data from response
        response = response.data
        that.attachments[that.attachments.length - 1].Data = response
        // console.log('--- response.data', response)

        // Replace form values with OCR values
        this.debtorZoneCode = this.$engine.bankAccounts.getZoneData('EU')

        let debtorName
        let debtorIdCompany
        let debtorIdProvider
        for (var key in exchangeData) {
          var ExtractedValue = response[exchangeData[key]]
          if (ExtractedValue) {
            if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
              ExtractedValue = ''
            }
            const today = moment().format('YYYY-MM-DD')
            // Formatting values from OCR to conform to accepted formats
            switch (exchangeData[key]) {
              case 'AdditionalInformation':
                that[key] = ExtractedValue.length ? ExtractedValue[0] : ''
                break
              case 'Amount':
                that[key] = ExtractedValue.replace(/,/g, '.')
                break
              case 'AmountTTC':
                that[key] = ExtractedValue
                // that.changeDebtorsAmount()
                break
              case 'CreditorIban':
              case 'DebtorIban':
                that[key] = ExtractedValue.replace(/ /g, '')
                break
              case 'DebtorId':
                debtorIdCompany = ExtractedValue
                break
              case 'DebtorName':
                debtorName = ExtractedValue
                break
              case 'DebtorProviderIdentifier':
                debtorIdProvider = ExtractedValue
                break
              case 'DuePayableAmount':
                that.amountTotal = ExtractedValue.replace(/,/g, '.')
                break
              case 'EndPeriodDate':
                that[key] = ExtractedValue
                if (moment(ExtractedValue).format('YYYY-MM-DD') <= today) {
                  that.acceptNow = true
                }
                break
              case 'ExecutionDate':
                that[key] = ExtractedValue
                if (moment(ExtractedValue).format('YYYY-MM-DD') <= today) {
                  that.payNow = true
                }
                break
              case 'Instalment':
                that.installments = []
                for (var i = 0; i < ExtractedValue.length; i++) {
                  that.installments.push({
                    amount: ExtractedValue[i]['Amount'],
                    date: ExtractedValue[i]['ExecutionDate'] + 'T00:00'
                  })
                }
                if (ExtractedValue.length != 0) {
                  that.multiInstallments = true
                } else {
                  that.multiInstallments = false
                }
                break
              case 'PaymentOptions':
                that.dateModifAccepted = ExtractedValue['EarlyPaymentAllowed'] === 1 ? true : false
                that.amountModifAccepted = ExtractedValue['AmountModificationAllowed'] === 1 ? true : false
                that.creditNote = ExtractedValue['CreditNote'] === 1 ? true : false
                break
              default:
                that[key] = ExtractedValue
            }
            //console.log("Key: " + key + ", Value: " + ExtractedValue)
            //console.log(that)
          }
        }
        let contact = {}
        if (debtorName) {
          const contacts = this.$engine.contacts.get().filter(e => e.name.toUpperCase() === debtorName.toUpperCase())
          if (contacts.length) {
            contact = contacts[0]
          }
        }
        that.enteredDebtors[0].debtorName = debtorName
        that.enteredDebtors[0].debtorIdCompany = debtorIdCompany ? debtorIdCompany : (contact.idCompany ? contact.idCompany : '')
        let oldIdProvider = that.enteredDebtors[0].debtorIdProvider
        let newIdProvider = debtorIdProvider ? debtorIdProvider : (contact.idProvider ? contact.idProvider : '')
        that.enteredDebtors[0].debtorIdProvider = newIdProvider
        if (oldIdProvider !== newIdProvider && this.$engine.rights.rightIs('rtp_norm_consulter', true)) {
          this.verifyNorm(this.enteredDebtors[0])
        }
        // Replace selected contact with new values (trigger child render function)
        /*this.$refs.selectContact.selectItem({
          name: this.debtorName,
          iban: this.debtorBank,
          identifier: this.debtorEmail,
          idCompany: this.debtorIdCompany,
          idProvider: this.debtorIdProvider
        })*/
      })
      .catch(error => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        that.$f7.alert('', that.$i18n.t('errors.Extract_unavailable'))
        // errorMessageAlert(error, that)
      })
    },
    executeOCR (e, fileType) {
      if (e === '' && this.fileEvent === '') {
        return
      } else if (e === '') {
        e = this.fileEvent
      }
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        // let id = this.attachments.length
        if (!this.attachments.length) {
          this.attachments.push({})
        }
        let id = 0
        var reader = new FileReader()
        reader.onload = (e) => {
          if (this.$engine.settings.get(Services.PAYMENTS).ocrActivation === '0') {
            this.attachmentData = reader.result
            this.attachments[id].AttachmentData = reader.result
            console.log('OCR features not activated.')
          } else if (this.fileType === '') {
            this.fileEvent = e
          } else {
            this.attachmentData = reader.result
            this.attachments[id].AttachmentData = reader.result
            if (this.fileIsFacturX) that.executeFacturX(reader.result)
            else if (this.attachments.length === 1) that.executeOCRFile(fileType, reader.result)
          }
        }
        this.attachmentName = files[0].name
        this.attachments[id].AttachmentName = files[0].name
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert('',
          this.$i18n.t('creation_forms.file_size') +
          Math.round(files[0].size / 1000) +
          this.$i18n.t('creation_forms.max_file_size') +
          '500 Kb',
          this.$i18n.t('creation_forms.max_size_title')
        )
      }
    },
    /** @author ERI- TLV
    * @date 27/03/2020
    * @brief méthode qui execute l'OCR à partir de l'Order transmis en paramètre
    *     et qui affiche les données retournées sur l'IHM
    * @param filetype may be: RIB, Invoice, Order
    * @param file est l'image chiffrée en base64
    */
    executeOCRFile (filetype, file) {
      let that = this

      // key : IHM reception parameter, value : OCR returned data
      const exchangeData = {
        'RIB': {
          debtorBank: 'Iban',
          debtorName: 'Name'
        },
        'INVOICE': {
          debtorName: 'Name',
          debtorBank: 'Iban',
          debtorEmail: 'Email',
          creditorBank: 'CreditorIBAN',
          executionDate: 'DeliveryDate',
          amount: 'Amount',
          invoiceReference: 'Reference',
          remittanceInformation: 'Reason',
          address: 'StreetName',
          city: 'TownName',
          postalCode: 'PostalCode',
          amountTVA: 'AmountTVA',
          amountHT: 'AmountHT'
        }
      }

      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return that.$engine.ocr.ocrRequest(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        console.log('response ocrRequest : ', response)
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        // console.log('begin', that.enteredDebtors)
        // Extract DocumentData from response
        response = response.data.ControlsInformations

        that.instantPayment = 0
        // Replace form values with OCR values
        that.debtorZoneCode = that.$engine.bankAccounts.getZoneData('EU')
        let fileTypeData = exchangeData[filetype]
        for (var key in fileTypeData) {
          if (response[fileTypeData[key]]) {
            var ExtractedValue = response[fileTypeData[key]].Value
            if (ExtractedValue) {
              if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
                ExtractedValue = ''
              }

              // Formatting values from OCR to conform to accepted formats
              if (fileTypeData[key] === 'Amount') {
                ExtractedValue = ExtractedValue.replace(/,/g, '.')
              } else if (fileTypeData[key] === 'Iban') {
                ExtractedValue = ExtractedValue.replace(/ /g, '')
              }

              if (key === 'debtorName') {
                let contacts = this.$engine.contacts.get()
                for (var kContact in contacts) {
                  if (contacts[kContact].name.toUpperCase() === ExtractedValue.toUpperCase()) {
                    that.enteredDebtors[0].debtorSelected = true
                    that.enteredDebtors[0].debtorEmail = contacts[kContact].identifier
                    if (!response['Iban'] || response['Iban'].Value === '') {
                      that.enteredDebtors[0].debtorBank = contacts[kContact].iban
                    }
                  }
                }
              } else if (key === 'executionDate') {
                let today = moment().format('YYYY-MM-DD')
                if (moment(ExtractedValue).format('YYYY-MM-DD') === today) {
                  that.instantPayment = 1
                }
              } else if (key === 'invoiceReference') {
                let id = that.attachments.length - 1
                that.invoiceReference = ExtractedValue
                that.attachments[id].InvoiceReference = ExtractedValue
              }

              let keyArray = ['amount', 'debtorName']
              if (keyArray.includes(key)) {
                that.enteredDebtors[0][key] = ExtractedValue
              } else {
                that[key] = ExtractedValue
              }
            }
          }
        }
        // Replace selected contact with new values (trigger child render function)
        // this.$refs.selectContact.selectItem({
        //   name: this.debtorName,
        //   iban: this.debtorBank,
        //   identifier: this.debtorEmail
        // })
        // console.log('end', that.enteredDebtors)
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        that.$f7.alert('',that.$i18n.t('errors.too_important_tilt'))
      })
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    generateInvoice (invoiceData) {
      const that = this
      this.enteredDebtors[0].debtorName = invoiceData.DebtorName
      if (invoiceData.DebtorSiren) {
        this.enteredDebtors[0].debtorEmail = invoiceData.DebtorSiren
      } else {
        this.enteredDebtors[0].debtorEmail = invoiceData.DebtorMail
      }
      this.enteredDebtors[0].debtorBank = invoiceData.DebtorIban
      this.creditorBank = invoiceData.CreditorIban
      this.enteredDebtors[0].amount = invoiceData.AmountTTC
      this.executionDate = invoiceData.ExecutionDate

      this.debtorData = {
        'name': this.enteredDebtors[0].debtorName,
        'identifier': this.enteredDebtors[0].debtorEmail,
        'address': invoiceData.DebtorAddress,
        'zipCode': invoiceData.DebtorZip,
        'city': invoiceData.DebtorCity,
        'country': invoiceData.DebtorCountry,
        'iban': this.enteredDebtors[0].debtorBank,
        'typeContact': invoiceData.DebtorSiren ? '2' : '1'
      }

      this.$f7.showPreloader('Génération de la facture en cours')
      this.$engine.services.generateFacturx(invoiceData)
      .then(response => {
        that.$f7.hidePreloader()
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: 'Facture générée',
            text: '<i class="fa-light fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
          }, 2000)

          let { DocumentName, DocumentData } = response.data
          let id = this.attachments.length
          this.attachments.push({})
          this.attachments[id].AttachmentData = DocumentData
          this.attachments[id].AttachmentName = DocumentName
        }
      })
      .catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    getIdentifierIcon (debtor) {
      switch (debtor.debtorIdType) {
        case 'mail':
          return 'fa-solid fa-envelope text-info'
        case 'phone':
          return 'fa-solid fa-phone text-info'
        default:
          return ''
      }
    },
    getIdentifierPlaceholder (debtor) {
      switch (debtor.debtorIdType) {
        case 'mail':
          return 'email@address.com'
        case 'phone':
          return '0600000000'
        default:
          return ''
      }
    },
    getNameDraft () {
      var namedraft = ''
      const that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-payment-create') {
        this.$f7.modal({
          title: this.$t('creation_forms.enter_drft_nm'),
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text"></div>',
          buttons: [
            {
              text: this.$t('common.cncl'),
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: this.$t('common.sve'),
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.saveInDraft(namedraft)
              }
            }
          ]
        })
      } else {
        this.saveInDraft(namedraft)
      }
    },
    goBack (url) {
      if (url !== 'none') {
        loadPage(this, {url: url})
      } else {
        /* On évite d'afficher la page de login a un utilisateur deja connecte */
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
          loadPage(this, {url: '/home/'})
        } else {
          this.$bus.$emit('router-back')
          this.$f7.mainView.router.back()
        }
      }
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, '1')
    },
    importRIB ($event) {
      this.Dom7(this.Dom7('.rib-file-input')[this.Dom7('.rib-file-input').length - 1]).click()
    },
    isBankAccountAvailable (bankAccount) {
      if (this.$engine.rights.rightIs('rtp_request_other_euro', false)) {
        return bankAccount.zoneCode === 'EUR'
      }
      return true
    },
    isDebtorAnonymous (debtor) {
      return debtor.debtorToken !== ''
    },
    isNorm (norm) {
      return this.norm === norm
    },
    loadDefaultNorm () {
      this.norm = this.getDefaultNorm
    },
    loadPreChargedDraft () {
      if (typeof (this.$settings.preChargedDraft) !== 'undefined') {
        for (let i = 0; i < this.bankAccounts.length; i++) {
          if (this.bankAccounts[i].iban === this.$settings.preChargedDraft.CreditorBankAccount) {
            this.creditorBankName = this.bankAccounts[i].name
          }
        }

        if (this.$settings.preChargedDraft.AttacAttachmentIdhmentName) {
          this.attachmentId = this.$settings.preChargedDraft.AttachmentId
        }
        if (this.$settings.preChargedDraft.AttachmentName) {
          this.attachmentName = this.$settings.preChargedDraft.AttachmentName
        }
        if (this.$settings.preChargedDraft.Attachment && this.$settings.preChargedDraft.Attachment !== '$NotFound') {
          this.attachmentData = this.$settings.preChargedDraft.Attachment
        }
        if (this.$settings.preChargedDraft.AttachmentReference) {
          this.attachmentReference = this.$settings.preChargedDraft.AttachmentReference
        }
        if (this.$settings.preChargedDraft.DebtorName) {
          this.debtorName = this.$settings.preChargedDraft.DebtorName
        }
        if (this.$settings.preChargedDraft.DebtorBankAccount) {
          this.debtorBank = this.$settings.preChargedDraft.DebtorBankAccount
        }
        if (this.$settings.preChargedDraft.DebtorIdentifier !== '') {
          this.debtorEmail = this.$settings.preChargedDraft.DebtorIdentifier
        }
        if (this.$settings.preChargedDraft.CreditorBankAccount !== '') {
          this.creditorBank = this.$settings.preChargedDraft.CreditorBankAccount
        }
        if (this.$settings.preChargedDraft.RemittanceInformation !== '') {
          this.remittanceInformation = this.$settings.preChargedDraft.RemittanceInformation
        }
        if (this.$settings.preChargedDraft.RequestedExecutionDate !== '') {
          this.executionDate = this.$settings.preChargedDraft.RequestedExecutionDate
        }
        if (this.$settings.preChargedDraft.Amount !== '') {
          this.amount = this.$settings.preChargedDraft.Amount
        }
        if (this.$settings.preChargedDraft.amountModifAccepted === 'true') {
          this.amountModifAccepted = true
        } else if (this.$settings.preChargedDraft.amountModifAccepted === 'false') {
          this.amountModifAccepted = false
        }
        if (this.$settings.preChargedDraft.instantPayment !== undefined && this.$settings.preChargedDraft.instantPayment !== '') {
          this.instantPayment = this.$settings.preChargedDraft.instantPayment
        }
        if (this.$settings.preChargedDraft.draftName !== '') {
          this.draftName = this.$settings.preChargedDraft.draftName
        }
        this.idDraft = this.$settings.preChargedDraft.idDraft
        this.ImmPmtAccepted = this.$settings.preChargedDraft.ImmPmtAccepted
        if (this.$settings.preChargedDraft.instantPayment !== undefined && this.$settings.preChargedDraft.instantPayment !== '') {
          this.instantPayment = this.$settings.preChargedDraft.instantPayment
        }
      }
      this.$settings.preChargedDraft = undefined
    },
    loadPreChargedFile () {
      if (typeof (this.$settings.preChargedFile) !== 'undefined') {
        if (this.$settings.preChargedFile.fromCloudList === true) {
          this.fromCloud = true
          this.attachmentId = this.$settings.preChargedFile.id
          this.attachmentName = this.$settings.preChargedFile.name
          this.attachmentData = this.$settings.preChargedFile.data
          this.attachmentReference = this.$settings.preChargedFile.reference
          this.amount = this.$settings.preChargedFile.amount
          this.executionDate = this.$settings.preChargedFile.executionDate
          this.debtorName = this.$settings.preChargedFile.debtorName
          this.debtorEmail = this.$settings.preChargedFile.debtorEmail
          this.debtorBank = this.$settings.preChargedFile.debtorBankAccount
          this.remittanceInformation = this.$settings.preChargedFile.remittanceInformation
          if (this.debtorName !== '' && this.debtorEmail === '') {
            let that = this
            this.contacts.forEach((contact, i) => {
              if (contact.name === this.$settings.preChargedFile.debtorName) {
                that.debtorName = contact.name
                that.debtorBank = contact.iban
                that.debtorEmail = contact.identifier
              }
            })
          }
        }
      }
      this.$settings.preChargedFile = undefined
    },
    openDoc (id) {
      const that = this
      if (this.attachments[id].AttachmentId) {
        let win = window
        this.$f7.showPreloader(this.$t('common.getting_file'))
        this.$engine.services.payments.getAttachmentDetail(this.attachments[id].AttachmentId)
          .then(response => {
            let dataB64 = response.data.documentData.split(',')[1]
            let contentType = response.data.documentData.split(';')[0].replace(/^data:/, '')
            let blob = b64toBlob(dataB64, contentType)
            let url = window.URL.createObjectURL(blob)
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$t('common.got_file'),
              buttons: [
                {
                  text: that.$t('common.open'),
                  onClick: function () {
                    win.open(url)
                  }
                }
              ]
            })
          })
          .catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
          })
      } else {
        if (
          this.$f7.device.os === 'android' ||
          this.$f7.device.os === 'ios'
        ) {
          this.$f7.hidePreloader()
          this.writeToFile(
            this.attachments[id].AttachmentName,
            this.attachments[id].AttachmentData,
            this.attachments[id].AttachmentData.split(';')[0].replace(/^data:/, ''),
            true,
            function (filePath, fileType, fileName) {
              that.readFile(filePath, fileType, fileName)
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        } else {
          let attachmentData = this.attachments[id].AttachmentData
          let blob = b64toBlob(attachmentData.split(',')[1], attachmentData.split(';')[0].replace(/^data:/, ''))
          const url = window.URL.createObjectURL(blob)
          window.open(url)
        }
      }
    },
    openImportAttachmentInvoice (fileType) {
      if (fileType === '1') {
        const that = this
        that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
      }
      /* TLV 12/09/2020 : Pour la démo du 23/09, le bouton d'attachments donnera directement accès
      * aux fichiers en local */
      /* let buttons1 = [
        {
          text: this.$t('common.import_device'),
          onClick: function () {
            that.attachmentData = ''
            that.attachmentName = ''
            that.attachmentId = ''
          }
        }
      ]
      if (this.hasCloudAttachments) {
        buttons1.push({
          text: this.$t('creation_forms.imprt_frm_moneyroad'),
          onClick: function (event, event2) {
            that.attachmentData = ''
            that.attachmentName = ''
            that.attachmentId = ''
            that.filesPicker(event2)
          }
        })
      }
      let buttons2 = [
        {
          text: this.$t('common.cncl'),
          color: 'red',
          onClick: function () {
          }
        }
      ]
      this.$f7.actions([buttons1, buttons2]) */
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(
          entry.nativeURL.replace(/%20/g, ' '),
          fileType,
          {
            error: function (e) {
              // TODO : screen user stuff
            },
            success: function (s) {
              // TODO : screen user stuff
            },
          }
        )
      })
    },
    resetForm () {
      this.acceptExpirationTime = '10'
      this.acceptNow = false
      this.amountModifAccepted = false
      this.amountTotal = ''
      this.amountTotalSaved = ''
      this.attachmentData = ''
      this.attachmentId = ''
      this.attachmentName = ''
      this.attachmentReference = ''
      this.attachmentReferenceError = false
      this.attachments = []
      this.beneficiaire = ''
      this.beneficiaireError = false
      this.canSendAttachment = true
      this.cloudDocsPicker = ''
      this.cloudFiles = []
      this.contacts = []
      this.contactsObject = {}
      this.contactsPicker = ''
      this.contactSelectionList = []
      this.creditNote = false
      this.creditorBank = ''
      this.creditorBankName = ''
      this.dateModifAccepted = false
      this.debtorBank = ''
      this.debtorEmail = ''
      this.debtorSRTP = ''
      this.debtorName = ''
      this.debtorData = {}
      this.debtorZoneCode = ''
      this.debugQRCode = false // If false, debug div wont be display
      this.doesAcceptNow = 'now'
      this.doesPayNow = 'later'
      this.draftName = ''

      this.enteredDebtors = []
      this.enteredDebtors.push({
        amount: '',
        debtorBank: undefined,
        debtorIdType: 'mail',
        debtorEmail: '',
        debtorId: '0',
        debtorName: '',
        debtorSelected: false,
        debtorToken: '',
        debtorIdCompany: '',
        debtorIdProvider: '',
        debtorImportedFound: false
      })
      this.executionDate = formatDateTime(moment().add(1,'days').format('YYYY-MM-DDT00:00'))
      this.expirationDate = formatDateTime(moment().add(1,'days').format('YYYY-MM-DDT00:00'))
      this.fileEvent = ''
      this.fileIsFacturX = true
      this.fileTypeSelect = [
        {
          text: this.$i18n.t('common.classic_invce_radio'),
          value: false
        },
        {
          text: this.$i18n.t('common.facturx_radio'),
          value: true
        }
      ]
      this.fromCloud = false
      this.hasCloudAttachments = false
      this.ibanModifAccepted = false
      this.idDraft = ''
      this.ImmPmtAccepted = false
      this.installmentsAccepted = false
      this.installments = []
      this.instantPayment = 1
      this.invoiceReference = ''
      this.isOcrActive = true
      this.isSCTInst = false
      this.loadingFile = false
      this.multiInstallments = false
      this.nbDebtors = '1'
      this.loadDefaultNorm()
      this.payExpirationTime = '10'
      this.payNow = false
      this.paymentOption = ['normal', 'CB', 'SCTInst']
      this.reasonModifAccepted = false
      this.refreshImport = false
      this.remittanceInformation = ''
      this.rtpType = 'unit'
      this.selected = []
      this.selectedContact = false
      this.selectedDebtors = {}
      this.typeFile = '1'
      this.uri = ''
      this.$engine.services.payments.contactDebtorList = []
      let defaultBankAccount = this.$engine.bankAccounts.get().find(elem => elem.isDefault === '1')
      if (defaultBankAccount) {
        this.creditorBank = defaultBankAccount.iban
        this.creditorBankName = defaultBankAccount.name
      }
    },
    resetFormHRTP () {
      this.acceptExpirationTime = '10'
      this.acceptNow = false
      this.addDocToRTP = false
      this.beneficiaire = ''
      this.beneficiaireError = false
      this.canSendAttachment = true
      this.cloudDocsPicker = ''
      this.cloudFiles = []
      this.creditNote = false
      this.dateModifAccepted = false
      this.debugQRCode = false // If false, debug div wont be display
      this.doesAcceptNow = 'now'
      this.doesPayNow = 'later'
      this.draftName = ''
      this.expirationDate = undefined
      this.ibanModifAccepted = false
      this.idDraft = ''
      this.ImmPmtAccepted = false
      this.installmentsAccepted = false
      this.installments = []
      this.instantPayment = 1
      this.isSCTInst = false
      this.multiInstallments = false
      this.norm = ''
      this.payExpirationTime = '10'
      this.payNow = false
      this.reasonModifAccepted = false
      this.uri = ''
    },
    saveInDraft (namedraft) {
      const that = this
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.amountModifAccepted ? 'true' : 'false'
      let debtorsInfo = []

      for (var property in this.selectedDebtors) {
        debtorsInfo.push({
          DebtorName: this.selectedDebtors[property].name,
          DebtorBankAccount: this.selectedDebtors[property].iban,
          // DebtorIdentifier: this.selectedDebtors[property].identifier
        })
      }
      for (var debtor in this.enteredDebtors) {
        debtorsInfo.push({
          DebtorName: this.enteredDebtors[debtor].debtorName,
          DebtorBankAccount: this.enteredDebtors[debtor].debtorBank,
          // DebtorIdentifier: this.enteredDebtors[debtor].debtorEmail
        })
      }
      if (debtorsInfo.length === 0) {
        debtorsInfo.push({
          DebtorName: '',
          DebtorBankAccount: '',
          // DebtorIdentifier: ''
        })
      }
      this.executionDate = formatDateTime(this.executionDate)
      let draftArray = []

      if (that.capsule === 'draft-edit') {
        let requestLoad = []
        requestLoad.push({
          'idDraft': this.idDraft,
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': that.creditorBank,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'CreditorName': this.$engine.user.get().name,
          'DebtorName': this.debtorName,
          'DebtorBankAccount': this.debtorBank,
          'DebtorIdentifier': this.debtorEmail,
          'RemittanceInformation': that.remittanceInformation,
          'ImmPmtAccepted': payModAcc,
          'PymtNtr': payNat,
          'RequestedExecutionDate': that.executionDate,
          'Amount': that.amount,
          'amountModifAccepted': that.amountModifAccepted,
          'AttachmentId': that.attachmentId,
          'AttachmentName': that.attachmentName,
          'AttachmentReference': that.attachmentReference,
          'Attachment': that.attachmentData,
          'DraftName': that.draftName,
          'instantPayment': that.instantPayment
        })

        this.$engine.drafts.update(requestLoad[0])
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/draft', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      } else {
        for (var deb in debtorsInfo) {
          draftArray.push({
            'idAccount': this.$engine.user.get().id,
            'CreditorBankAccount': that.creditorBank,
            'CreditorIdentifier': this.$engine.user.get().identifier,
            'CreditorName': this.$engine.user.get().name,
            'DebtorName': debtorsInfo[deb].DebtorName,
            'DebtorBankAccount': debtorsInfo[deb].DebtorBankAccount,
            'DebtorIdentifier': debtorsInfo[deb].DebtorIdentifier,
            'RemittanceInformation': that.remittanceInformation,
            'ImmPmtAccepted': payModAcc,
            'PymtNtr': payNat,
            'RequestedExecutionDate': that.executionDate,
            'Amount': that.amount,
            'amountModifAccepted': that.amountModifAccepted,
            'AttachmentId': that.attachmentId,
            'AttachmentName': that.attachmentName,
            'AttachmentReference': that.attachmentReference,
            'Attachment': that.attachmentData,
            'DraftName': namedraft
          })
        }
        let requestLoad = {
          'drafts': draftArray
        }
        that.$engine.drafts.create(requestLoad)
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/draft', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    scanDocument ($event) {
      /* eslint-disable no-undef */
      let that = this
      this.locationTypeFile = 0
      var options = {
        quality: 100,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }
      const bla = true
      if (bla) {
        let id = 0
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()

              reader.onloadend = function (e) {
                that.attachmentData = e.target.result.split(',')[1]
                that.attachmentName = 'Invoice.jpeg'

                if (!that.attachments.length) {
                  that.attachments.push({
                    AttachmentName: 'Invoice.jpeg',
                    AttachmentData: e.target.result
                  })
                }
                if (that.fileIsFacturX) {
                  that.executeFacturX(e.target.result)
                } else {
                  that.executeOCRFile('INVOICE', e.target.result.split(',')[1])
                }
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      } else {
        console.log('OCR Non Actif')
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                that.fileContentArray.push(e.target.result)
              }

              let ca = that
              that.$f7.modal({
                title: 'Please enter the name of the scan',
                // text: 'Enter a name of draft',
                afterText: '<div class="item-input"><input class="inputnamescan" type="text"></div>',
                buttons: [
                  {
                    text: 'Cancel',
                    color: 'red',
                    onClick: function () {
                    }
                  },
                  {
                    text: 'Done',
                    onClick: function () {
                      var lab = ca.Dom7('.inputnamescan').val()
                      ca.fileNameArray.push(lab)
                    }
                  }
                ]
              })
              that.attachmentReference = ''
              that.attachmentId = ''

              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    scanQRCode (debtorId) {
      // console.log(debtorId)
      this.$bus.$emit('popup-scanner-qr-code', debtorId)
    },
    checkUniqueDate(array) {
      const uniqueValues = new Set()
      for (let i = 0; i < array.length; i++) {
        const date = array[i].date
        if (uniqueValues.has(date)) {
          return false
        }
        uniqueValues.add(date)
      }
      return true
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(
          function (status) {
            switch (status) {
              case cordova.plugins.diagnostic.permissionStatus.GRANTED:
                // console.log('Permission granted')
                sucess()
                break
              case cordova.plugins.diagnostic.permissionStatus.DENIED:
                // console.log('Permission denied')
                error()
                break
              case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                console.log('Permission permanently denied')
                error()
                break
            }
          },
          function (error) {
            console.error('The following error occurred: ' + error)
          },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(
        directory,
        function (directoryEntry) {
          directoryEntryReference = directoryEntry
          directoryEntry.getFile(
            fileName,
            { create: true, exclusive: true },
            function (fileEntry) {
              fileEntry.createWriter(
                function (fileWriter) {
                  fileWriter.onwriteend = function (e) {
                    success(e.target.localURL, fileType, fileName)
                  }
                  fileWriter.onerror = function (e) {
                    error()
                  }
                  let blob = b64toBlob(
                    data.replace(/^[^,]*,/, ''),
                    fileType
                  )
                  fileWriter.write(blob)
                },
                (e, file) => {}
              )
            },
            (e, file) => {
              navigator.notification.confirm(
                'This file already exists do you want to override it ? (' +
                  fileName +
                  ')',
                function (index) {
                  /* console.log(
                    'Do you want to override the following file: ' +
                      fileName +
                      ' (' +
                      index +
                      ')'
                  ) */
                  switch (index) {
                    case 1: // No
                      // console.log('No. Returning to idle state.')
                      break
                    case 2: // Yes -> overrides  the file
                      // console.log('Yes. Overriding file.')
                      directoryEntryReference.getFile(
                        fileName,
                        { create: true, exclusive: false },
                        function (fileEntry) {
                          fileEntry.createWriter(
                            function (fileWriter) {
                              fileWriter.onwriteend = function (e) {
                                success(e.target.localURL, fileType, fileName)
                              }
                              fileWriter.onerror = function (e) {
                                error()
                              }
                              let blob = b64toBlob(
                                data.replace(/^[^,]*,/, ''),
                                fileType
                              )
                              fileWriter.write(blob)
                            },
                            (e, file) => {}
                          )
                        },
                        (e, file) => {}
                      )
                      break
                  }
                },
                'Information',
                ['No', 'Yes']
              )
            }
          )
        },
        (e, file) => {
          // error resolveLocalFileSystemURL
        }
      )
      /* eslint-enable no-undef */
    },
    sendPayments () {
      let that = this
      let requestAlertText = ''
      let responseAlertText = ''
      let groupIdentifier = ''
      let groupReference = ''
      let urlRedirect = ''
      let listPath = ''

      if (this.canSeeRTPBack && !this.canSeeRTPFront) {
        listPath = 'listBack'
      } else {
        listPath = 'list'
      }

      if (this.enteredDebtors.length > 1) {
        requestAlertText = this.$t('requestToPay.rtp_sending_plur')
        responseAlertText = this.$t('requestToPay.rtp_sent_plur')
        groupIdentifier = 'GRP_' + moment().format('YYYYMMDDhhmmss') + '_' + Math.random().toString(36).substr(2, 6)
        groupReference = this.remittanceInformation
        urlRedirect = '/rtp/' + listPath + '/2/2/'
      } else {
        requestAlertText = this.$t('requestToPay.rtp_sending')
        responseAlertText = this.$t('requestToPay.rtp_sent')
        urlRedirect = '/rtp/' + listPath + '/2/1'
      }

      this.Dom7('input').addClass('display-error')
      this.Dom7('input').focus()
      this.Dom7('button').focus()
      this.Dom7('input').removeClass('display-error')

      let isError = false
      this.maxAmountError = false
      this.ibanFormatError = false
      this.$f7.showPreloader(requestAlertText)

      if (this.norm === 'HRTP') {
        this.maxAmount = parseInt(this.maxAmount).toString()
      }
      // check if amount matches max amount settings
      this.maxAmount = !this.settings.maxAmount ? (this.norm === 'SRTP' ? this.settings.SRTPmaxAmount : this.settings.HRTPmaxAmount) : this.settings.maxAmount
      if (this.norm === 'HRTP' && this.amountTotal && !Number.isInteger(parseFloat(this.amountTotal))) {
        this.maxAmountError = true
        this.maxAmountErrorText = 'errors.max_amt_cents'
        isError = true
      }
      if (parseFloat(this.amountTotal) > parseFloat(this.maxAmount)) {
        // this.$f7.alert('', this.$t('Le montant total de la demande doit être inférieur ou égal à ' + maxAmount))
        this.maxAmountError = true
        this.maxAmountErrorText = 'errors.max_amt_authrsd'
        isError = true
      }

      if (!this.amountTotal || !parseFloat(this.amountTotal)) {
        // this.$f7.alert('', this.$t('Le montant total de la demande doit être supérieur à 0'))
        isError = true
      }

      // check creditor bank account selected
      if (this.creditorBank === '') {
        that.$$('.myAccountBlock').show()
        that.$$('.senderChevron').transform('rotate(90deg)')
        // this.$f7.alert('', this.$t('errors.miss_creditor'))
        isError = true
      }
      // check reason
      if (this.remittanceInformation === '') {
        // this.$f7.alert('', this.$t('errors.enter_reason'))
        isError = true
      }
      // check dates executionDate
      const today = moment().format('YYYY-MM-DD')
      if (!this.payNow) {
        if ((this.executionDate === '' && !this.dateModifAccepted) || moment(this.executionDate).format('YYYY-MM-DD') < today) {
          // this.$f7.alert('', this.$t('errors.invld_exec_dt'))
          isError = true
        } else if (moment(this.executionDate).format('YYYY-MM-DD') === today &&
            this.installmentsAccepted && !this.dateModifAccepted) {
          // this.$f7.alert('', this.$t('errors.exec_dt_nd_instllmnts'))
          isError = true
        }
        if (moment(this.executionDate).format('YYYY-MM-DD') === today) {
          this.instantPayment = 1
        }
      }

      // check dates expirationDate
      if (!this.acceptNow) {
        if ((this.expirationDate === '') || moment(this.expirationDate).format('YYYY-MM-DD') < today) {
          // this.$f7.alert('', this.$t('errors.invld_expiration_dt'))
          isError = true
        }
      }

      // check option pay now
      if (this.doesPayNow === 'now') {
        if (!this.payExpirationTime || this.payExpirationTime === '0') {
          // this.$f7.alert('You must set an expiration time for the paiement', 'Payment Expiration Time missing')
          isError = true
        }
      } else {
        this.payExpirationTime = ''
      }
      // check option accept now
      if (this.doesAcceptNow === 'now') {
        if (!this.acceptExpirationTime || this.acceptExpirationTime === '0') {
          // this.$f7.alert('You must set an expiration time for the acceptation', 'Acceptation Expiration Time missing')
          isError = true
        }
      } else {
        this.acceptExpirationTime = ''
      }

      // check option instalments
      let installments = undefined
      if (this.multiInstallments) {
        let error = false
        this.installments.forEach((installment, indexInstallment) => {
          if ((installment.amount === '' || installment.amount === '0' || installment.date === '') && !error) {
            // this.$f7.alert(that.$t('errors.fulfill_installment'), that.$t('errors.empty_installment'))
            error = true
            return
          }
        })
        if (error) {
          isError = true
        }
        /*let instalmentDatesArray = this.installments.map(elem => moment(elem.date).format('DD/MM/YYYY'))
        if ((new Set(instalmentDatesArray)).size !== instalmentDatesArray.length) {
          this.$f7.alert(that.$t('errors.installment_date_duplicate'), that.$t('errors.installment_duplicate'))
          return false
        }*/
        if (this.checkUniqueDate(this.installments) === false) {
          // this.$f7.alert(that.$t('errors.installment_duplicate'), that.$t('errors.installment_date'))
          isError = true
        }

        let currentDate = new Date()
        let isDatesValid = this.installments.every(item => {
          let itemDate = new Date(formatDateTime(item.date))
          return itemDate >= currentDate
        })

        if (!isDatesValid && false) {
          // this.$f7.alert(that.$t('errors.installment_date_inf_today'), that.$t('errors.installment_date'))
          isError = true
        }

        installments = []
        this.installments.forEach(installment => {
          installments.push({
            Amount: installment.amount,
            Currency: that.bankAccounts.find(acc => acc.iban === this.creditorBank).zoneCode,
            RequestedExecutionDate: formatDateTime(installment.date)
          })
        })

        let totalAmountInstallments = this.installments.map(elem => parseFloat(elem.amount)).reduce((partialAmount, elem) => partialAmount + elem, 0)
        if (parseFloat(this.amountTotal) !== parseFloat(totalAmountInstallments.toFixed(2))) {
          // this.$f7.alert(that.$t('errors.installment_amount_sum_error'), that.$t('errors.installment_sum_error'))
          isError = true
        }
        /*this.executionDate = moment(new Date(Math.max.apply(null, this.installments.map(function(e) {
          return new Date(moment(e.date).format('YYYY-MM-DD'))
        })))).format('YYYY-MM-DD')*/
      }

      let nbRTPSent = 1

      for (var debtorId in this.enteredDebtors) {
        let debtor = this.enteredDebtors[debtorId]
        let debtorsInfo = []

        if (debtor.debtorToken) {
          debtorsInfo.push({
            DebtorProprietaryAccount: debtor.debtorToken
          })
        } else {
          debtorsInfo.push({
            DebtorIdentifier: debtor.debtorIdCompany ? debtor.debtorIdCompany : undefined,
            DebtorName: debtor.debtorName,
            DebtorProviderIdentifier: debtor.debtorIdProvider,
            DebtorAccountIdentifier: debtor.debtorBank
          })
        }

        // check if adding debtor has error
        if (!this.addDebtor(debtor)) {
          that.$f7.hidePreloader()
          isError = true
        }

        // check if debtor iban is validated
        if(this.isNorm('HRTP') && debtor.debtorBank) {
          if (!validateIBAN(debtor.debtorBank) || !validateIBANRIBKey(debtor.debtorBank)) {
            that.$f7.hidePreloader()
            that.ibanFormatError = true
            isError = true
          }
        }

        // check amount
        let amount = parseFloat(debtor.amount)
        if (!amount && !this.amountModifAccepted) {
          that.$f7.hidePreloader()
          // this.$f7.alert('', this.$t('errors.miss_amount'))
          isError = true
        } else if (amount < 0 || (amount === 0 && !this.amountModifAccepted)) {
          that.$f7.hidePreloader()
          // this.$f7.alert('', this.$t('errors.invld_amnt'))
          isError = true
        }

        if (isError) {
          that.$f7.hidePreloader()
          this.$f7.alert('', this.$t('errors.errors_in_form_details'))
          return
        }

        let currency

        if (this.isNorm('HRTP')) {
          currency = 'HUF'
        } else {
          currency = that.bankAccounts.find(acc => acc.iban === this.creditorBank).zoneCode
        }


        // set options
        let ImmPmtAcc = this.ImmPmtAccepted ? 'true' : 'false'
        let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
        this.executionDate = this.payNow ? 'NOW' : this.executionDate
        this.expirationDate = this.acceptNow? 'NOW' : this.isNorm('HRTP') ? undefined : this.expirationDate
        let jsonToCreate = {
          CreditorIdentifier: this.$engine.settings.get().clientIdentifier,
          CreditorAccountIdentifier: that.creditorBank,
          CreditorName: this.$engine.user.get().name,
          Debtors: debtorsInfo,
          EndToEndId: that.invoiceReference ? that.invoiceReference : undefined,
          RemittanceInformation: that.remittanceInformation,
          ImmPmtAccepted: ImmPmtAcc,
          Instalments: installments,
          PymtNtr: payNat,
          RequestedExecutionDate: that.executionDate,
          RequestedExpirationDate: that.expirationDate,
          Amount: debtor.amount % 1 === 0 ? debtor.amount : Number.parseFloat(debtor.amount).toFixed(2),
          Currency: currency,
          Accept: (this.doesAcceptNow ? 'now' : 'later'),
          AcceptExpirationTime: this.acceptExpirationTime,
          Pay: this.doesPayNow,
          PayExpirationTime: this.payExpirationTime,
          AcceptModifyAmount: (this.amountModifAccepted ? '1' : '0'),
          AcceptModifyExecutionDate: (this.dateModifAccepted ? '1' : '0'),
          AcceptModifyBankAccount: (this.ibanModifAccepted ? '1' : '0'),
          AcceptModifyRemittanceInformation: (this.reasonModifAccepted ? '1' : '0'),
          AcceptMultipleInstalments: (this.installmentsAccepted ? '1' : '0'),
          InstantPayment: '1',
          PaymentOption: this.paymentOption,
          Standard: this.typeOfRTP
        }
        if (this.attachments && this.attachments.length) {
          let docName = this.attachments[0].AttachmentName.split('.')
          docName.splice(this.attachments[0].AttachmentName.split('.').length - 1, 1)
          docName = docName.join('.')
          jsonToCreate.Attachments = [{
            Attached: this.addDocToRTP ? '1' : '0',
            Type: this.DocumentTypeCode === '381' ? 'CINV' : 'CREN',
            TypeType: 'Code',
            Identifier: ((this.attachments[0].Data && this.attachments[0].Data.InvoiceReference) ? this.attachments[0].Data.InvoiceReference : docName),
            Date: ((this.attachments[0].Data && this.attachments[0].Data.CreationDate) ? this.attachments[0].Data.CreationDate : moment().format('YYYY-MM-DD')),
            Name: docName,
            Format: this.attachments[0].AttachmentName.split('.')[this.attachments[0].AttachmentName.split('.').length - 1].toUpperCase(),
            FormatType: 'Code',
            Content: this.attachments[0].AttachmentData.split(',')[1] // data sans header
          }]
        }
        if (groupIdentifier !== '') {
          jsonToCreate.GroupId = groupIdentifier
          jsonToCreate.GroupReference = groupReference
        }
        if (this.creditNote) {
          jsonToCreate.CreditNote = {
            Amount: jsonToCreate.Amount,
            Currency: jsonToCreate.Currency
          }
          jsonToCreate.Amount = 0
        }
        if (this.uri && this.uri.length) {
          jsonToCreate.URI = this.uri
          jsonToCreate.URIRequired = '1'
        }
        that.$engine.services.payments
        .create(jsonToCreate)
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            // that.$engine.settings.set({sessionToken: response.headers['x-session-token']})
            let paymentsSent = false
            if (that.enteredDebtors.length === 1 ||
              (that.enteredDebtors.length > 1 && nbRTPSent === that.enteredDebtors.length)) {
              paymentsSent = true
            }
            if (paymentsSent) {
              that.$bus.$emit('payments-sent')
              that.$f7.hidePreloader()
              this.$f7.modal({
                title: responseAlertText,
                text: '<i class="fa-light fa-check"></i>'
              })
              this.$engine.services.payments.debtorList = []
              this.$engine.services.payments.contactDebtorList = []
              setTimeout(function () {
                that.$f7.closeModal()
                that.$bus.$emit('switch-selected-menu', urlRedirect)
                loadPage(that, {url: urlRedirect})
              }, 2000)
            } else {
              nbRTPSent++
            }
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    // setContacts () {
    //   let that = this
    //   this.$engine.services.payments.contactDebtorList = []
    //   this.$engine.services.payments.contactGroupsSelected = []
    //   this.contacts = this.$engine.contacts.get()
    //   this.contacts.forEach((contact, i) => {
    //     that.contactsObject[that.contacts[i].id] = that.contacts[i]
    //   })
    //   var contactList = {}
    //   for (var j = 0; j < this.$engine.contacts.get().length; j++) {
    //     var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
    //     if (!contactList.hasOwnProperty(firstLetter)) {
    //       contactList[firstLetter] = []
    //     }
    //     contactList[firstLetter].push({
    //       label: this.$engine.contacts.get(j).label,
    //       iban: this.$engine.contacts.get(j).iban,
    //       identifier: this.$engine.contacts.get(j).identifier,
    //       idCompany: this.$engine.contacts.get(j).idCompany,
    //       idProvider: this.$engine.contacts.get(j).idProvider,
    //       name: this.$engine.contacts.get(j).name,
    //       id: this.$engine.contacts.get(j).id
    //     })
    //     contactList[firstLetter].sort()
    //   }
    //   this.contactSelectionList = contactList
    //   console.log('contact selection list', this.contactSelectionList)
    // },
    showDevisForm () {
      this.debtorData = {
        'name': this.enteredDebtors[0].debtorName,
        'identifier': this.enteredDebtors[0].debtorEmail,
        'address': this.address,
        'zipCode': this.postalCode,
        'city': this.city,
        'country': this.country,
        'iban': this.enteredDebtors[0].debtorBank,
        'typeContact': this.enteredDebtors[0].DebtorSiren ? '2' : '1'
      }
      let products = []
      if (this.remittanceInformation || this.amountHT) {
        products.push({
          Desc: this.remittanceInformation,
          Qte: '1',
          Amount: this.amountHT
        })
      }
      this.$bus.$emit('popup-devis-form', {
        invoiceType: 'FacturX',
        invoiceRef: this.attachmentReference,
        dateExec: moment(this.executionDate).format('YYYY-MM-DD'),
        sellerIBAN: this.creditorBank,
        amountHT: this.enteredDebtors[0].AmountHT,
        amountTaxes: this.amountTVA,
        buyer: {
          ...this.debtorData,
          ...{
            name: this.enteredDebtors[0].debtorName,
            identifier: this.enteredDebtors[0].debtorEmail,
            iban: this.enteredDebtors[0].debtorBank
          }
        },
        products: products
      })
    },
    verifyNorm (debtor) {
      let that = this
      let idProvider = debtor.debtorIdProvider
      if (this.lastProviderTested === idProvider && this.norm) {
        return
      }
      this.lastProviderTested = idProvider
      let regexIdProvider = /^([A-Z]{6,6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3,3}){0,1})$/
      if (!idProvider) {
        this.norm = 'NONE'
        return
      } else if (regexIdProvider.test(idProvider) === false) {
        this.norm = 'NONE'
        return
      }
      this.norm = ''
      this.$engine.services.payments.getNorm(idProvider)
      .then(resp => {
        let newNorm = resp.data[idProvider]
        if (newNorm === 'HRTP') {
          //Changer la date d'execution à aujourd'hui et à l'heure d'aujourd'hui lorsqu'on passe en HRTP
          this.executionDate = formatDateTime(moment().format('YYYY-MM-DDThh:mm:ss'))
        }
        this.typeOfRTP = (newNorm === 'HRTP' ? '2' : '1')
        if (newNorm) {
          if (that.norm !== newNorm) {
            this.maxAmountError = false
            this.ibanFormatError = false
          }
          if ((!that.canDoSRTP && newNorm === 'SRTP') || (!that.canDoHRTP && newNorm === 'HRTP')) {
            that.norm = 'FORBIDDEN'
          } else {
            that.norm = newNorm
          }
        } else {
          that.norm = 'NONE'
        }
      })
      .catch(err => {
        that.norm = ''
      })
    },
    view (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let that = this
      if (this.attachments[id].AttachmentId) {
        this.$f7.showPreloader(this.$t('common.opnng_fl'))
        this.$engine.services.payments.getAttachmentDetail(this.attachments[id].AttachmentId)
          .then(response => {
            this.$engine.settings.set({Attachment: {
              data: response.data.documentData,
              name: response.data.documentName,
              mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
              id: id
            }})
            if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
              that.writeToFile(
                response.data.documentName,
                response.data.documentData,
                response.data.documentData.split(';')[0].replace(/^data:/, ''),
                true,
                function (filePath, fileType, fileName) {
                  that.readFile(filePath, fileType, fileName)
                },
                function () {
                  that.$f7.alert('', that.$t('errors.err_crtng_fl'))
                }
              )
            } else {
              let dataB64 = response.data.documentData.split(',')[1]
              let contentType = response.data.documentData.split(';')[0].replace(/^data:/, '')
              let blob = b64toBlob(dataB64, contentType)
              let url = window.URL.createObjectURL(blob)
              let fileLink = document.createElement('a')
              fileLink.href = url
              fileLink.setAttribute('download', response.data.documentName)
              fileLink.click()
            }
            setTimeout(function () { that.$f7.hidePreloader() }, 1000)
            this.$f7.alert('', this.$i18n.t('Fichier téléchargé avec succès !'))
          })
          .catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // errorMessageAlert(error, that)
          })
      } else {
        if (
          this.$f7.device.os === 'android' ||
          this.$f7.device.os === 'ios'
        ) {
          this.$f7.hidePreloader()
          this.writeToFile(
            this.attachments[id].AttachmentName,
            this.attachments[id].AttachmentData,
            this.attachments[id].AttachmentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType, fileName) {
              that.readFile(filePath, fileType, fileName)
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        } else {
          let attachmentData = this.attachments[id].AttachmentData
          let attachmentName = this.attachments[id].AttachmentName
          let dataB64 = attachmentData.split(',')[1]
          let contentType = attachmentData.split(';')[0].replace(/^data:/, '')
          let blob = b64toBlob(dataB64, contentType)
          let url = window.URL.createObjectURL(blob)
          let fileLink = document.createElement('a')
          fileLink.href = url
          fileLink.setAttribute('download', attachmentName)
          fileLink.click()
          // TO DO
        }
      }
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (this.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (this.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        this.saveFileToDirectory(
          fileName,
          data,
          fileType,
          directory,
          success,
          error
        )
      } else {
        // directory = cordova.file.externalRootDirectory
        if (this.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (this.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          this.checkForWritePermissions(
            function () {
              try {
                window.resolveLocalFileSystemURL(
                  directory,
                  function (directoryEntry) {
                    directoryEntry.getDirectory(
                      'Download',
                      { create: true },
                      function (downloadDir, _data) {
                        that.saveFileToDirectory(
                          fileName,
                          data,
                          fileType,
                          downloadDir.nativeURL,
                          function (filePath, fileType) {
                            console.log('sucess saving file: ', filePath)
                          },
                          function (error, _data) {
                            console.error('error on saving file' + error.code)
                            alert('Unable to save file: ' + error.code)
                          }
                        )
                      },
                      function (error, _data) {
                        console.error(
                          'error on accessing download directory' + error.code
                        )
                        alert(
                          'Unable to get/create download directory: ' +
                            error.code
                        )
                      }
                    )
                  },
                  (e, file) => {
                    // error resolveLocalFileSystemURL
                  }
                )
              } catch (error) {
                // get dir
                console.error(error)
              }
            },
            function () {
              alert(
                'App needs access to the phone\'s file storage in order to save files.'
              )
            }
          )
        } catch (error) {
          // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    /*currencySymbol(curr) */
    zoneCodeToSign (zoneCode) {
      if (this.isNorm('SRTP')) {
        switch (zoneCode) {
          case 'EUR':
            return '(€)'
        }
      } else if (this.isNorm('HRTP')) {
        return '(ft)'
      }
      return ''
     }
  }
}
</script>
